import {
    Component, ViewEncapsulation, OnInit, ViewChild, EventEmitter, Input, Output, TemplateRef, AfterContentInit, QueryList, ContentChildren,

    Compiler, ComponentRef, Injector, NgModule, NgModuleRef, ViewContainerRef, AfterViewInit,
    NgZone,
} from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { UtilityService } from '../services/utility-service/utility-service';
import { TriggerType } from '../model/rules/TriggerType.enum';
import { ActionType } from '../model/rules/ActionType.enum';
import { GoToPageTypes } from '../model/rules/GoToPageTypes.enum';
import { ActionRulesType } from '../model/rules/ActionRulesType.enum';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { Router, ActivatedRoute } from '@angular/router';
import { AgentscriptService } from '../services/agentscript-services/agentscript.service';
import { SectionBuilderService } from '../services/sectionbuilder-services/sectionbuilder';
import { AppService } from '../app.service';
import { StandardUIService } from '../services/standardui-service/standardui-service';
import { SystemobjectsService } from '../services/objectservice/systemobjects.service';
import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SpinnerVisibilityService } from 'ng-http-loader';
import { MetaData } from '../services/metadata/metadata.service';
import { ObjectController } from '../services/object-controller/objectcontroller.service';
import { ReportViewModuleModule } from '../report-view-module/report-view-module.module';
import { TabViewModuleModule } from '../tab-view-module/tab-view-module.module';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { Context } from '../model/context';
import { TrackingViewModuleModule } from '../tracking-view-module/tracking-view-module.module';
import { BabyStatusConditionsModule } from '../baby-status-conditions/baby-status-conditions.module';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';
import { ProgressBarModule } from '../progress-bar/app-progress-bar.module';
import { CardViewModule } from '../card-view/card-view.module';
// import { BreadcrumbService } from '../SmartReporter/sm-Services/breadcrumb.service';
import { NoteModuleModule } from '../note-module/note-module.module';
import { LocalStorageService } from 'src/app/services/localstorage-service/localstorage-service';
import { AgentscriptService_updated } from '../services/agent-script-service/agent-script-service';
import { QueryBuilderViewModuleModule } from '../query-builder-module/query-builder-view-module.module';
import { AttachmentsViewModuleModule } from '../attachments/attachments-view-module/attachments-view-module.module';
import { setTime } from 'ngx-bootstrap/chronos/utils/date-setters';
import { FroalaEditorModule } from 'angular-froala-wysiwyg'
import { BreadcrumbService } from '../services/sm-Services/breadcrumb.service';
import { catchError, throwError, timeout, Subscription, forkJoin, of, switchMap } from 'rxjs';
import { ApiserviceService } from '../Service/apiservice.service';
import { MatDialog } from '@angular/material/dialog';
import { ContactLookupDialogComponent } from '../NewServiceRequest/contact-lookup-dialog/contact-lookup-dialog.component';
declare var $: any;
require('../../assets/vendor/js/inputmask.js');
require('../../assets/vendor/js/chosen.js');
@Component({
    selector: 'app-page-preview',
    templateUrl: './preview-component.html',
    styleUrls: ['./preview.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class PreviewComponent implements OnInit {

    step_form: any;
    @ViewChild('modalBody', { read: ViewContainerRef }) modalBody: ViewContainerRef;
    private cmpRef: ComponentRef<any>;

    loading = true;
    components = [];
    contextData: any;
    loadingPrev = false;
    containerHeight: any;
    tcontainer = {};
    @Input() dataFromDynamicComponent;
    @Output() componentSelection = new EventEmitter<any>();

    /**
     * True when this SR loaded with anonymous contact from `setUIData` / `setUIDataNewSr` (payload).
     * Never cleared on uncheck: every time Anonymous is unchecked, we enable Contact ID lookup and
     * keep all other `contactidobject` fields readonly (repeat check/uncheck).
     * Not set when the user only toggles Anonymous during the session without that initial payload.
     */
    anonymousFromInitialPayload = false;

    // Static cache for compiled dynamic component factories
    private static templateFactoryCache = new Map<string, any>();

    private subscriptions: Subscription[] = [];

    constructor(
        private agentscriptservice_updated: AgentscriptService_updated,
        private breadcumbservice: BreadcrumbService,
        private agentscriptService: AgentscriptService,
        private apiservice:ApiserviceService,
        private sectionBuilderService: SectionBuilderService,
        private appService: AppService,
        private utilityService: UtilityService,
        private compiler: Compiler,
        private injector: Injector,
        private route: ActivatedRoute,
        private router: Router,
        private moduleRef: NgModuleRef<any>,
        private objService: SystemobjectsService,
        private standardService: StandardUIService,
        private formBuilder: FormBuilder,
        //public activeModal: NgbActiveModal,
        //    private pageBuilderService: PageBuilderService,
        private spinnerService: SpinnerVisibilityService,
        private metadata: MetaData,

        private objcontroller: ObjectController,
        private localStorageService: LocalStorageService,
        private ngZone: NgZone,
        private dialog: MatDialog
    ) {

    }

    /** Contact lookup popup (query 23) is limited to Fort Wayne Admin — see `localStorage.role`. */
    isFortWayneAdminRole(): boolean {
        try {
            return localStorage.getItem('role') === 'Fort Wayne Admin';
        } catch {
            return false;
        }
    }

    /** Match `Entity.contactidobject.field` in `name` (case-insensitive — DOM may differ from metadata). */
    private static readonly CONTACT_OBJECT_NAME_MARKER_LOWER = '.contactidobject.';
    /** Real Contact.id when the visible input shows `First Last` instead of the numeric id. */
    private static readonly CONTACT_ID_STORED_ATTR = 'data-contactid-stored-value';

    /** Anonymous Contact.id from citizen web portal vs admin agent portal (must not be rewritten on load). */
    private static readonly ANONYMOUS_CONTACT_ID_WEB_PORTAL = '10';
    private static readonly ANONYMOUS_CONTACT_ID_ADMIN_PORTAL = '11';

    private static isAnonymousPortalSentinelId(raw: string | undefined | null): boolean {
        const s = String(raw ?? '').trim();
        return (
            s === PreviewComponent.ANONYMOUS_CONTACT_ID_WEB_PORTAL ||
            s === PreviewComponent.ANONYMOUS_CONTACT_ID_ADMIN_PORTAL
        );
    }

    /**
     * Used only when applying the anonymous mask from loaded API data (`runAnonymousToggleFromPayload`).
     * Preserves Contact.id 10 (web) or 11 (admin) from payload or DOM. User-driven checkbox checks use
     * admin sentinel 11 instead (see `applyAnonymousContactMask` and `preservePayloadAnonymousSentinel`).
     */
    private resolveAnonymousSentinelContactId(idInput: HTMLInputElement): string {
        const stored = idInput.getAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
        if (PreviewComponent.isAnonymousPortalSentinelId(stored)) {
            return String(stored).trim();
        }
        const visible = String(idInput.value ?? '').trim();
        if (PreviewComponent.isAnonymousPortalSentinelId(visible)) {
            return visible;
        }
        const cobj =
            (this.contextData?.payLoad?.contactidobject as Record<string, unknown> | undefined) ||
            (this.dataFromDynamicComponent?.newSr?.payLoad?.contactidobject as Record<string, unknown> | undefined);
        const idVal = cobj?.id;
        if (PreviewComponent.isAnonymousPortalSentinelId(idVal != null ? String(idVal) : '')) {
            return String(idVal).trim();
        }
        return PreviewComponent.ANONYMOUS_CONTACT_ID_ADMIN_PORTAL;
    }

    /** True for `*.contactidobject.id` text inputs (not hidden). */
    isContactIdObjectIdField(nameAttr: string | undefined): boolean {
        if (!nameAttr) {
            return false;
        }
        const n = nameAttr.toLowerCase();
        return n.includes('.contactidobject.') && n.endsWith('.id');
    }

    /** Backend value for Contact.id: stored attr when input shows display name, else `value`. */
    readContactIdInputBackendValue(input: HTMLInputElement): string {
        const stored = input.getAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
        if (stored != null && stored !== '') {
            return stored;
        }
        return String(input.value ?? '').trim();
    }

    private static looksLikeNumericContactId(raw: string): boolean {
        return /^\d+$/.test(String(raw ?? '').trim());
    }

    /**
     * Show `First Last` in the Contact ID field when first/last have text; keep the numeric id in
     * `data-contactid-stored-value` for submit. If names are cleared, restore the visible value from storage.
     */
    private syncContactIdDisplayAsConcatNames($root: JQuery): void {
        const $first = $root.find(
            'input[name*="contactidobject"][name$=".firstname"], textarea[name*="contactidobject"][name$=".firstname"]'
        );
        const $last = $root.find(
            'input[name*="contactidobject"][name$=".lastname"], textarea[name*="contactidobject"][name$=".lastname"]'
        );
        const fn = String($first.first().val() ?? '').trim();
        const ln = String($last.first().val() ?? '').trim();
        const display = `${fn} ${ln}`.trim();

        $root
            .find('input[name*="contactidobject"][name$=".id"]')
            .not('[type="hidden"]')
            .each(function (this: HTMLInputElement) {
                const inp = this;
                const stored = inp.getAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
                const rawVisible = String(inp.value ?? '').trim();

                if (!display) {
                    if (stored != null && stored !== '') {
                        inp.value = stored;
                        inp.removeAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
                    }
                    return;
                }

                let backend = stored != null && stored !== '' ? stored : '';
                if (!backend && PreviewComponent.looksLikeNumericContactId(rawVisible)) {
                    backend = rawVisible;
                }
                if (!backend) {
                    return;
                }
                inp.setAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR, backend);
                inp.value = display;
            });
    }

    /** Re-run Contact ID display vs first/last (after load, lookup, anonymous, or name edits). */
    refreshContactIdConcatDisplay(randomPageId: string | number): void {
        this.syncContactIdDisplayAsConcatNames($(`[data-uniquepageid='${String(randomPageId)}']`));
    }

    /** Anonymous toggle from generated UI (checkbox `name` is derived from the field label). */
    private findAnonymousCheckboxInPreview($root: JQuery): JQuery {
        return $root.find('input[type="checkbox"]').filter(function (this: HTMLInputElement) {
            return (this.getAttribute('name') || '').toLowerCase() === 'anonymous';
        });
    }

    /**
     * User checked Anonymous or payload requires anonymous: mask, lookup lock, then re-apply readonly/lookup
     * on later ticks so other handlers/bindings cannot leave fields editable (re-check after load is common).
     * @param maskOpts `preservePayloadAnonymousSentinel`: true only for deferred load from `runAnonymousToggleFromPayload`
     *        so web sentinel id 10 is kept; omit or false for UI checkbox so Contact.id becomes admin id 11.
     */
    private applyAnonymousCheckedPipeline(
        randomPageId: string | number,
        maskOpts?: { preservePayloadAnonymousSentinel?: boolean }
    ): void {
        const rid = randomPageId;
        this.applyAnonymousContactMask(rid, maskOpts);
        this.applyLookupContactFieldLock(rid);
        const relock = () => {
            this.applyAnonymousReadonlyFlagsOnly(rid);
            this.applyLookupContactFieldLock(rid);
        };
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => this.ngZone.run(() => relock()), 0);
            setTimeout(() => this.ngZone.run(() => relock()), 50);
            setTimeout(() => this.ngZone.run(() => relock()), 150);
        });
    }

    /**
     * Turn on anonymous UI from loaded payload. Does not rely only on `.trigger('change')` — that can run
     * before the document delegate exists or while `setUIData` is still writing fields; defer the same
     * pipeline used for a user click.
     */
    private runAnonymousToggleFromPayload(randomPageId: string | number): void {
        const $root = $(`[data-uniquepageid='${randomPageId}']`);
        const $cb = this.findAnonymousCheckboxInPreview($root);
        if ($cb.length) {
            $cb.prop('checked', true);
        }
        this.ngZone.runOutsideAngular(() => {
            setTimeout(() => {
                this.ngZone.run(() =>
                    this.applyAnonymousCheckedPipeline(randomPageId, {
                        preservePayloadAnonymousSentinel: true,
                    })
                );
            }, 0);
        });
    }

    /**
     * Walk every `*contactidobject*` field in the preview root. Uses `.contactidobject.` in `name` so we
     * still find controls when `dataFromDynamicComponent.entityName` does not match the form (e.g. Incident
     * in HTML vs metadata).
     */
    private forEachContactObjectField(
        $root: JQuery,
        fn: (el: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, fieldKey: string) => void
    ): void {
        const marker = PreviewComponent.CONTACT_OBJECT_NAME_MARKER_LOWER;
        $root.find('input, textarea, select').each(function (this: HTMLElement) {
            const nm = (this.getAttribute('name') || '').trim();
            const nmLower = nm.toLowerCase();
            const ix = nmLower.indexOf(marker);
            if (ix === -1) {
                return;
            }
            if (nmLower === 'anonymous') {
                return;
            }
            if (this instanceof HTMLInputElement) {
                const t = this.type.toLowerCase();
                if (t === 'checkbox' || t === 'radio' || t === 'hidden') {
                    return;
                }
            }
            const fieldKey = nm.slice(ix + marker.length);
            if (!fieldKey) {
                return;
            }
            fn(this as HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement, fieldKey);
        });
    }

    /**
     * Every role: `.lookup_contact` is not typable (pointer-events on inputs — use lookup / display only).
     * Non–Fort Wayne Admin also get class `lookup-contact-locked` (grey readonly look in styles.scss).
     * Fort Wayne Admin: same lock so fields are not writable; click on `.lookup_contact` opens lookup dialog.
     */
    applyLookupContactFieldLock(randomPageId: string | number): void {
        const preview = this;
        const pid = String(randomPageId);
        const $scope = $(`[data-uniquepageid='${pid}']`);
        const $blocks = $scope.find('.lookup_contact');
        if (this.isFortWayneAdminRole()) {
            $blocks.removeClass('lookup-contact-locked');
        } else {
            $blocks.addClass('lookup-contact-locked');
        }

        /* Clear prior lock inline styles before re-applying. Otherwise an input that was non-readonly
         * (lookup: pointer-events none) and later becomes readonly (e.g. Anonymous re-checked) keeps
         * pointer-events none — clicks miss the input, hit .lookup_contact, and reopen lookup wrongly. */
        $scope.find('.lookup_contact input, .lookup_contact textarea, .lookup_contact select').each(function (
            this: HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
        ) {
            if (this.tagName.toLowerCase() === 'input') {
                const t = ((this as HTMLInputElement).type || '').toLowerCase();
                if (
                    t === 'hidden' ||
                    t === 'checkbox' ||
                    t === 'radio' ||
                    t === 'button' ||
                    t === 'submit' ||
                    t === 'file' ||
                    t === 'reset'
                ) {
                    return;
                }
            }
            const $el = $(this);
            $el.removeAttr('tabindex').css('pointer-events', '');
        });

        const lockInput = ($el: JQuery) => {
            const el = $el.get(0) as HTMLInputElement | undefined;
            if (!el || el.readOnly || el.disabled) {
                return;
            }
            try {
                if (typeof ($el as any).inputmask === 'function') {
                    ($el as any).inputmask('remove');
                }
            } catch {
                /* noop */
            }
            $el.attr('tabindex', '-1').css('pointer-events', 'none');
        };

        $scope.find('.lookup_contact input').each(function (this: HTMLInputElement) {
            const t = (this.type || '').toLowerCase();
            if (
                t === 'hidden' ||
                t === 'checkbox' ||
                t === 'radio' ||
                t === 'button' ||
                t === 'submit' ||
                t === 'file' ||
                t === 'reset'
            ) {
                return;
            }
            lockInput($(this));
        });
        $scope.find('.lookup_contact textarea').each(function (this: HTMLTextAreaElement) {
            const $el = $(this);
            if (this.readOnly || this.disabled) {
                return;
            }
            $el.attr('tabindex', '-1').css('pointer-events', 'none');
        });
        $scope.find('.lookup_contact select').each(function (this: HTMLSelectElement) {
            const $el = $(this);
            if (this.disabled) {
                return;
            }
            $el.attr('tabindex', '-1').css('pointer-events', 'none');
        });

        $scope.find('.lookup_contact').each(function (this: HTMLElement) {
            const $block = $(this);
            const isSkippableInputType = (inp: HTMLInputElement): boolean => {
                const t = (inp.type || '').toLowerCase();
                return (
                    t === 'hidden' ||
                    t === 'checkbox' ||
                    t === 'radio' ||
                    t === 'button' ||
                    t === 'submit' ||
                    t === 'file' ||
                    t === 'reset'
                );
            };
            const $byContactId = $block.find('input[name*="contactidobject"][name$=".id"]');
            const $textInputs = $block.find('input').filter(function (this: HTMLInputElement) {
                return !isSkippableInputType(this);
            });
            const $target = ($byContactId.length ? $byContactId : $textInputs).first();
            const $taFallback = $block.find('textarea').first();
            const el = (
                $target.length
                    ? ($target.get(0) as HTMLInputElement | HTMLTextAreaElement)
                    : $taFallback.length
                      ? ($taFallback.get(0) as HTMLTextAreaElement)
                      : undefined
            );
            const nm = el ? el.getAttribute('name') || '' : '';
            const isContactIdInput =
                el instanceof HTMLInputElement && preview.isContactIdObjectIdField(nm);
            /* Non–Fort Wayne Admin cannot use contact lookup (`openContactLookupDialog` is gated); hide
             * magnifier — otherwise `readonly` is often unset while `.lookup-contact-locked` only greys. */
            const hideSearch =
                !!el &&
                (el.readOnly ||
                    el.hasAttribute('readonly') ||
                    (isContactIdInput && !preview.isFortWayneAdminRole()));
            if (hideSearch) {
                $block.addClass('lookup-contact-hide-search');
            } else {
                $block.removeClass('lookup-contact-hide-search');
            }
        });
    }

    /**
     * When Anonymous is unchecked after load, restoring only from `payLoad.contactidobject` fails if the
     * API omitted keys or sent null `id` for anonymous — jQuery `.val(undefined)` clears Contact ID and
     * `readonly` is never removed for keys missing from the object. Strip readonly from all contact fields
     * under this preview, then re-apply values only when present (skip null/undefined).
     */
    restoreContactFieldsWhenAnonymousUnchecked(randomPageId: string | number): void {
        const ent = this.dataFromDynamicComponent.entityName;
        const prefix = `${ent}.contactidobject.`;
        const pid = String(randomPageId);
        const $root = $(`[data-uniquepageid='${pid}']`);
        this.forEachContactObjectField($root, (el) => {
            if (el instanceof HTMLInputElement && this.isContactIdObjectIdField(el.getAttribute('name') || '')) {
                el.removeAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
            }
            el.removeAttribute('readonly');
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                el.readOnly = false;
            }
            if (el instanceof HTMLSelectElement) {
                el.disabled = false;
            }
        });
        const cobj = this.contextData?.payLoad?.contactidobject as Record<string, unknown> | undefined;
        if (cobj && typeof cobj === 'object') {
            const addrSkip = `${ent}.contactidobject.addressid`;
            for (const key of Object.keys(cobj)) {
                const fieldName = prefix + key;
                if (fieldName === addrSkip) {
                    continue;
                }
                const v = cobj[key];
                if (v === undefined || v === null) {
                    continue;
                }
                $root.find(`[name^='${fieldName}']`).val(v as any).addClass('changed');
            }
        }
        /* Payload still carries anonymous sentinels (id 10 web / 11 admin, "Anonymous" names) — clear so
         * uncheck shows a real "identify contact" state: empty Contact ID for lookup, no placeholder names. */
        this.clearAnonymousSentinelContactValues($root);
        /* Payload-loaded anonymous: after every uncheck, Contact ID stays lookupable; all other contact
         * fields stay readonly (same on repeated check/uncheck). */
        if (this.anonymousFromInitialPayload) {
            this.applyReadonlyToContactFieldsExceptContactId(pid);
        }
        this.refreshContactIdConcatDisplay(randomPageId);
    }

    /** After unchecking Anonymous: remove API anonymous placeholders from the form (not the in-memory payload). */
    clearAnonymousSentinelContactValues($root: JQuery): void {
        const ANON_EMAIL = 'anonymous@thesmartcity311.com';
        const contactField = (suffix: string) =>
            `input[name*="contactidobject"][name$=".${suffix}"], textarea[name*="contactidobject"][name$=".${suffix}"]`;
        $root
            .find(`input[name*="contactidobject"][name$=".id"]`)
            .not('[type="hidden"]')
            .each(function (this: HTMLInputElement) {
                const stored = this.getAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
                const raw =
                    stored != null && stored !== ''
                        ? stored
                        : String($(this).val() ?? '').trim();
                if (PreviewComponent.isAnonymousPortalSentinelId(raw)) {
                    $(this).val('').addClass('changed');
                }
            });
        $root.find(contactField('firstname')).each(function (this: HTMLInputElement | HTMLTextAreaElement) {
            const v = String($(this).val() ?? '').trim().toLowerCase();
            if (v === 'anonymous') {
                $(this).val('').addClass('changed');
            }
        });
        $root.find(contactField('lastname')).each(function (this: HTMLInputElement | HTMLTextAreaElement) {
            const v = String($(this).val() ?? '').trim().toLowerCase();
            if (v === 'anonymous') {
                $(this).val('').addClass('changed');
            }
        });
        $root
            .find(`${contactField('email')}, ${contactField('emailalt1')}`)
            .each(function (this: HTMLInputElement | HTMLTextAreaElement) {
                const v = String($(this).val() ?? '').trim().toLowerCase();
                if (v === ANON_EMAIL || v === 'anonymous') {
                    $(this).val('').addClass('changed');
                }
            });
    }

    /**
     * Anonymous checked: set every `*.contactidobject.*` control in the form to the anonymous pattern.
     * Uses the DOM (not only `payLoad.contactidobject` keys) so re-checking Anonymous after uncheck
     * still updates every field — iterating only API keys can miss `id` or leave stale pointer-events.
     * @param maskOpts When `preservePayloadAnonymousSentinel` is true (payload load), keep id 10 (web) or 11 (admin) from API.
     *        When false or omitted (agent checks Anonymous in the portal), Contact.id is always admin sentinel 11.
     */
    applyAnonymousContactMask(
        randomPageId: string | number,
        maskOpts?: { preservePayloadAnonymousSentinel?: boolean }
    ): void {
        const pid = String(randomPageId);
        const $root = $(`[data-uniquepageid='${pid}']`);
        this.forEachContactObjectField($root, (el, fieldKey) => {
            const $field = $(el);
            if (el instanceof HTMLSelectElement) {
                el.disabled = false;
            }
            if (fieldKey === 'id') {
                const idStr = maskOpts?.preservePayloadAnonymousSentinel
                    ? this.resolveAnonymousSentinelContactId(el as HTMLInputElement)
                    : PreviewComponent.ANONYMOUS_CONTACT_ID_ADMIN_PORTAL;
                el.setAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR, idStr);
                $field.val(idStr).addClass('changed');
            } else if (fieldKey === 'firstname' || fieldKey === 'lastname') {
                $field.val('Anonymous').addClass('changed');
            } else if (fieldKey === 'email') {
                $field.val('anonymous@thesmartcity311.com').addClass('changed');
            } else {
                $field.val('').addClass('changed');
            }
            el.setAttribute('readonly', 'readonly');
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                el.readOnly = true;
            }
            if (el instanceof HTMLSelectElement) {
                el.disabled = true;
            }
        });
        this.syncContactIdDisplayAsConcatNames($root);
    }

    /**
     * Re-apply readonly flags only (no value changes). Used after a tick so repeat Anonymous checks still
     * stay locked if something in the stack cleared the attribute.
     */
    applyAnonymousReadonlyFlagsOnly(randomPageId: string | number): void {
        const pid = String(randomPageId);
        const $root = $(`[data-uniquepageid='${pid}']`);
        this.forEachContactObjectField($root, (el) => {
            el.setAttribute('readonly', 'readonly');
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                el.readOnly = true;
            }
            if (el instanceof HTMLSelectElement) {
                el.disabled = true;
            }
        });
        this.syncContactIdDisplayAsConcatNames($root);
    }

    /**
     * Lock every `*.contactidobject.*` field except Contact ID (lookup) after unchecking Anonymous when
     * this SR had anonymous contact in the **initial payload** (`anonymousFromInitialPayload`).
     */
    applyReadonlyToContactFieldsExceptContactId(randomPageId: string | number): void {
        const pid = String(randomPageId);
        const $root = $(`[data-uniquepageid='${pid}']`);
        this.forEachContactObjectField($root, (el, fieldKey) => {
            if (fieldKey === 'id') {
                if (el instanceof HTMLSelectElement) {
                    el.disabled = false;
                }
                return;
            }
            el.setAttribute('readonly', 'readonly');
            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                el.readOnly = true;
            }
            if (el instanceof HTMLSelectElement) {
                el.disabled = true;
            }
        });
    }

    /** True if click is on a readonly/disabled control (do not open contact lookup). */
    contactLookupClickShouldIgnore(e: MouseEvent, currentTarget: Element): boolean {
        const x = e.clientX;
        const y = e.clientY;

        const isReadonlyOrDisabledInput = (el: HTMLInputElement | HTMLTextAreaElement): boolean => {
            if (el.disabled) {
                return true;
            }
            return el.readOnly || el.hasAttribute('readonly');
        };

        let stack: Element[];
        try {
            stack = document.elementsFromPoint(x, y);
        } catch {
            return false;
        }

        for (const el of stack) {
            if (!currentTarget.contains(el)) {
                continue;
            }
            if (el === currentTarget) {
                break;
            }

            if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
                if (isReadonlyOrDisabledInput(el)) {
                    return true;
                }
            }
            if (el instanceof HTMLSelectElement && el.disabled) {
                return true;
            }

            if (el instanceof HTMLLabelElement) {
                let ctl: Element | null = null;
                const lab = el as HTMLLabelElement;
                if (lab.htmlFor) {
                    const root = currentTarget.getRootNode();
                    if (root instanceof Document || root instanceof ShadowRoot) {
                        ctl = root.getElementById(lab.htmlFor);
                    }
                    if (!ctl) {
                        ctl = document.getElementById(lab.htmlFor);
                    }
                }
                if (!ctl && lab.control) {
                    ctl = lab.control;
                }
                if (!ctl) {
                    ctl = lab.querySelector('input, textarea, select');
                }
                if (ctl instanceof HTMLInputElement || ctl instanceof HTMLTextAreaElement) {
                    if (isReadonlyOrDisabledInput(ctl)) {
                        return true;
                    }
                }
                if (ctl instanceof HTMLSelectElement && ctl.disabled) {
                    return true;
                }
            }
        }

        const ptIn = (r: DOMRect) =>
            x >= r.left && x <= r.right && y >= r.top && y <= r.bottom && r.width > 0 && r.height > 0;

        const controls = currentTarget.querySelectorAll('input, textarea, select');
        for (let i = 0; i < controls.length; i++) {
            const node = controls[i];
            const t = node.getAttribute('type')?.toLowerCase() ?? '';
            if (node instanceof HTMLInputElement && (t === 'hidden' || t === 'checkbox' || t === 'radio')) {
                continue;
            }
            if (!(node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement)) {
                if (node instanceof HTMLSelectElement) {
                    if (node.disabled && ptIn(node.getBoundingClientRect())) {
                        return true;
                    }
                }
                continue;
            }
            if (isReadonlyOrDisabledInput(node) && ptIn(node.getBoundingClientRect())) {
                return true;
            }
        }

        return false;
    }

    /**
     * Reads contact-related inputs inside the clicked `.lookup_contact` wrapper (name ending in
     * firstname, lastname, phonenumber, email, street on `*.contactidobject.*`).
     */
    collectContactLookupValuesFromDiv($div: JQuery): {
        phonenumber?: string;
        firstname?: string;
        lastname?: string;
        email?: string;
        street?: string;
    } {
        const o: {
            phonenumber?: string;
            firstname?: string;
            lastname?: string;
            email?: string;
            street?: string;
        } = {};
        $div.find('input, textarea').each(function () {
            const $el = $(this);
            const name = ($el.attr('name') || '').toLowerCase();
            const val = String($el.val() ?? '').trim();
            if (!name || val === '') {
                return;
            }
            const parts = name.split('.');
            const last = parts[parts.length - 1] || '';
            if (last === 'firstname') {
                o.firstname = val;
            } else if (last === 'lastname') {
                o.lastname = val;
            } else if (last === 'phonenumber') {
                o.phonenumber = val;
            } else if (last === 'email') {
                o.email = val;
            } else if (last === 'street') {
                o.street = val;
            }
        });
        return o;
    }

    openContactLookupDialog(randomPageId: string | number, $lookupDiv?: JQuery): void {
        if (!this.isFortWayneAdminRole()) {
            return;
        }
        const pid = String(randomPageId);
        const initial =
            $lookupDiv && $lookupDiv.length
                ? this.collectContactLookupValuesFromDiv($lookupDiv)
                : {};
        const digits = (initial.phonenumber || '').replace(/\D/g, '');
        this.dialog
            .open(ContactLookupDialogComponent, {
                width: '70vw',
                maxHeight: '90vh',
                data: {
                    ...initial,
                    phonenumber: digits.length >= 10 ? digits : initial.phonenumber?.replace(/\D/g, '') || ''
                }
            })
            .afterClosed()
            .subscribe((result: { rowdata: any[]; rowcolumns: string[] } | undefined) => {
                if (result?.rowdata && result?.rowcolumns) {
                    this.applyContactLookupResultToForm(pid, result);
                }
            });
    }

    applyContactLookupResultToForm(
        randomPageId: string,
        entireresult: { rowdata: any[]; rowcolumns: string[] }
    ): void {
        const row = entireresult.rowdata;
        const cols = entireresult.rowcolumns;
        const idx = (label: string) => cols.findIndex((c: string) => c === label);
        const ent = this.dataFromDynamicComponent.entityName;
        const prefix = `${ent}.contactidobject.`;
        const $r = $(`[data-uniquepageid='${randomPageId}']`);

        const setField = (suffix: string, colLabel: string) => {
            const i = idx(colLabel);
            if (i < 0 || row[i] === undefined || row[i] === null) {
                return;
            }
            $r.find(`[name='${prefix}${suffix}']`).val(String(row[i])).trigger('change').addClass('changed');
        };

        setField('id', 'Contact Id');
        setField('firstname', 'First Name');
        setField('lastname', 'Last Name');
        setField('email', 'Email Address');
        setField('phonenumber', 'Phone Number');
        setField('alternateph', 'Alternate Phone');
        setField('emailalt1', 'Alternate Email');
        setField('street', 'Street');
        setField('city', 'City');
        setField('postalcode', 'Postalcode');

        $r.find('input[name*="contactidobject"][name$=".id"]').not('[type="hidden"]').each(function (this: HTMLInputElement) {
            this.removeAttribute(PreviewComponent.CONTACT_ID_STORED_ATTR);
        });

        this.refreshContactIdConcatDisplay(randomPageId);

        const si = idx('Street');
        const ci = idx('City');
        const zi = idx('Postalcode');
        const street = si >= 0 ? row[si] ?? '' : '';
        const city = ci >= 0 ? row[ci] ?? 'Fort Wayne' : 'Fort Wayne';
        const zip = zi >= 0 ? row[zi] ?? '' : '';
        const mailing = `${street}\n${city} IN ${zip}\nUnited States (US)`.trim();
        if (mailing.length > 3) {
            $r.find(`[name='${prefix}addressid']`).val(mailing).trigger('change').addClass('changed');
        }

        this.applyLookupContactFieldLock(randomPageId);

        if (this.isMultiAccessLocation() && this.dataFromDynamicComponent?.entityName === 'Incident'
            && !this.dataFromDynamicComponent?.hasOwnProperty('newSr')) {
            $('.pane:visible .dynamic-form').find('.submit-form').attr('disabled', 'disabled');
        } else {
            $('.pane:visible .dynamic-form').find('.submit-form').removeAttr('disabled');
        }
    }
    objectMetaData: any;
    triageStatus: any;
    referrencenumber: any;
    tab_title: any;
    casescriptinfo: any;
    clearsetTimeout: any[] = [];
    private formDomReady = false;
    private objectDataReady = false;

    private resetFormLoadState(): void {
        this.formDomReady = false;
        this.objectDataReady = false;
    }

    private applyTriageStatusFromContextData(data: any): void {
        if (data?.entityName === 'Triage' && data.payLoad?.hasOwnProperty('done')) {
            this.triageStatus = data.payLoad.done === true;
        } else {
            this.triageStatus = false;
        }
    }

    private resolveObjectData$() {
        const comp = this.dataFromDynamicComponent;
        if (comp.id && !comp.hasOwnProperty('newSr') && !comp.hasOwnProperty('actiontype')) {
            return this.objcontroller.getObjectData(comp.id, comp.entityName);
        }
        if (comp.hasOwnProperty('newSr')) {
            return of(comp.newSr);
        }
        return of(null);
    }

    private markFormDomReady(): void {
        this.formDomReady = true;
        this.maybeApplyFormDataToPreview();
    }

    private maybeApplyFormDataToPreview(): void {
        if (!this.formDomReady || !this.objectDataReady || !this.objectMetaData) {
            return;
        }
        if (this.dataFromDynamicComponent.id && !this.dataFromDynamicComponent.hasOwnProperty('newSr')) {
            if (this.contextData?.payLoad) {
                this.setUIData(this.contextData);
            }
        } else if (this.dataFromDynamicComponent.hasOwnProperty('newSr') && this.contextData?.payLoad) {
            this.setUIDataNewSr(this.contextData);
        }
        this.applyMultiAccessFieldLocks();
    }

    /** True when me API user location is Multi Access (SR queue open restrictions). */
    isMultiAccessLocation(): boolean {
        try {
            const user = JSON.parse(this.localStorageService.get('currentUser') || 'null');
            return user?.location?.locationname === 'Multi Access'
                || localStorage.getItem('locationname') === 'Multi Access';
        } catch {
            return false;
        }
    }

    /**
     * Multi Access users opening an existing SR: Status, Further Details, and Submit locked.
     * Selects use disabled (HTML readonly is ignored on &lt;select&gt;).
     */
    applyMultiAccessFieldLocks(): void {
        if (!this.isMultiAccessLocation()) {
            return;
        }
        if (this.dataFromDynamicComponent?.hasOwnProperty('newSr')) {
            return;
        }
        if (this.dataFromDynamicComponent?.entityName !== 'Incident') {
            return;
        }
        const root = `[data-uniquepageid='${this.randomID}']`;
        const $status = $(`${root} [name='Incident.incidentstatus']`);
        $status.attr('readonly', 'readonly').attr('disabled', 'disabled');

        const $further = $(`${root} [name='Incident.furtherdetails'], ${root} textarea[name*='furtherdetails']`);
        $further.attr('readonly', 'readonly');

        $(`${root}`).closest('form.dynamic-form').find('.submit-form').attr('disabled', 'disabled');
        $(`[data-uniquepageid='${this.randomID}']`).closest('.dynamic-form').find('.submit-form').attr('disabled', 'disabled');
        $('.pane:visible .dynamic-form').find('.submit-form').attr('disabled', 'disabled');
    }

    escapeJsonRecursively(obj: any): any {
        if (Array.isArray(obj)) {
            return obj.map(item => this.escapeJsonRecursively(item)); // Recursively handle arrays
        } else if (typeof obj === 'object' && obj !== null) {
            let escapedObj: Record<string, any> = {}; // Ensure correct object type
            for (let key in obj) {
                escapedObj[key] = this.escapeJsonRecursively(obj[key]); // Recursively escape values
            }
            return escapedObj;
        } else if (typeof obj === 'string') {
            return this.escapeJsonString(obj); // Escape only string values
        }
        return obj; // Return numbers, booleans, null, etc., as-is
    }
    escapeJsonString(json: string): string {
        return json
            .replace(/</g, "\\u003C")
            .replace(/>/g, "\\u003E")
            .replace(/'/g, "\&#39;") // Escape single quotes
            .replace(/"/g, '\\"'); // Escape double quotes
            
            // .replace(/\\/g, '\\\\')  // Escape backslashes
            // .replace(/"/g, '&quot;')  // Escape double quotes for HTML attributes
            // .replace(/'/g, '&#39;')   // Escape single quotes safely for HTML
            // .replace(/{/g, '{{ "{" }}')  // Escape curly braces for Angular
            // .replace(/}/g, '{{ "}" }}'); // Escape curly braces for Angular
    }
    ngOnInit() {
        this.resetFormLoadState();
        $(document).off('.preview_' + this.randomID);
        this.tab_title = $(".custom-tabs li.active").find("a").attr('data-obj-title')
        this.casescriptinfo = this.agentscriptservice_updated.fetchData(this.tab_title, 'serviceTypeInfo')
        let navbarH = $('.layout-navbar').height();
        let docH = $(window).height();
        this.containerHeight = (docH - navbarH - 170) + 'px';

        this.tcontainer = {
            'height': this.containerHeight,
            'overflow': 'hidden',
            'overflow-y': 'auto'
        };
       // this.loading = false;
       // console.log(this.dataFromDynamicComponent);
        // return false;
        // //console.log(this.dataFromDynamicComponent.newsr.payLoad.refno)
        // this.referrencenumber=this.dataFromDy namicComponent.newsr.payLoad.refno
        if (this.dataFromDynamicComponent.type == 'object') {
            const departmentArray = {
                'Solid Waste': 13,
                'Streets': 14,
                'Street Lighting': 15,
                'Neighborhood Code Compliance': 19,
                'Signal Shop': 16,
                'Sign Shop': 17,
                'Animal Care and Control': 20,
                'Filtration': 21,
                'Fire Department': 22,
                'Forestry': 23,
                'Water Maintenance': 28,
                'Sewer': 27,
                'Parking Control': 26,
                'Purchasing': 25,
                'Property Management': 24,
                'Right of Way': 18,
                'Information Ticket': 29,
                'Contact': 31,
                'Answer': 36,
                'Sla': 10,
                'Deptcasedefination': 33,
                'Risk Management': 35,
                'Prodcat': 36
            };
            const pageId = departmentArray[this.dataFromDynamicComponent.department];
            const loadSub = forkJoin({
                meta: this.metadata.getObjectMetaData(this.dataFromDynamicComponent.entityName),
                objectData: this.resolveObjectData$()
            }).pipe(
                switchMap(({ meta, objectData }) => {
                    this.objectMetaData = meta;
                    if (objectData) {
                        this.contextData = objectData;
                        this.applyTriageStatusFromContextData(objectData);
                    }
                    this.objectDataReady = true;
                    return this.agentscriptService.getPageById(pageId);
                })
            ).subscribe((data: any) => {
                data = this.escapeJsonRecursively(data);
                var context: Context = null;
                if (this.dataFromDynamicComponent.entityName && this.dataFromDynamicComponent.id) {
                    context = new Context();
                    context.entityName = this.dataFromDynamicComponent.entityName;
                    context.id = this.dataFromDynamicComponent.id;
                    context.triageStatus = this.triageStatus;
                }

                this.clearsetTimeout.push(setTimeout(() => {
                    if (data && data.sections.length > 0) {
                        this.step_form = [];
                        this.step_form[0] = data;
                        let template: string = '';
                        template += '<form class="dynamic-form">';
                        data.sections.forEach(section => {
                            let fields = section.rowsitems;
                            template += '<div class="row">';

                            if (this.dataFromDynamicComponent.hasOwnProperty('newSr') || this.dataFromDynamicComponent.entityName != 'Incident') {
                                template += '<div class="col-md-12">';
                                if (this.dataFromDynamicComponent.hasOwnProperty('newSr')) {
                                    template += '<button style="top:8px" title="Print" (click)="print()" type="button" class="btn btn-outline-primary print-form "><i class="bi bi-printer"></i></button>';
                                }
                            } else {
                                template += '<div class="col-md-9" style="border-right: 2px solid #e9f0f6;">';

                                if (this.dataFromDynamicComponent.entityName == 'Incident') {
                                    template += '<button title="Print" (click)="print()" type="button" class="btn btn-outline-primary print-form" style="top:8px" ><i class="bi bi-printer"></i></button>';
                                }
                            }
                            template += '<div data-uniquepageid="' + this.randomID + '" data-entityname="' + this.dataFromDynamicComponent.entityName + '" data-entityid="' + this.dataFromDynamicComponent.id + '" data-elementid="' + section.id + '" class="card preview-card nopadding" data-pageid="' + data.id + '">';
                            template += '<div class="card-body" [ngStyle]=\'' + JSON.stringify(context) + '\'>';
                            template += '<button class="btn btn-outline-primary btn-xs preview-refresh" (click)="refresh()"><i class="fa fa-refresh mr-2"></i><span>Refresh</span></button>';
                            template += this.standardService.renderHtml(fields, section, context);
                            template += '</div>';
                            template += '</div>';
                            template += '</div>';
                            if (!this.dataFromDynamicComponent.hasOwnProperty('newSr') && this.dataFromDynamicComponent.entityName == 'Incident') {
                                template += '<div class="col-md-3 incident-print" [ngStyle]=\'' + JSON.stringify(this.tcontainer) + '\'>';

                                template += '<app-incident [context]=\'' + JSON.stringify(context) + '\'></app-incident>';
                                template += '</div>';
                            }
                            template += '</div>';
                        });
                        template += '<div class="row my-2 preview-submit">';
                        template += '<div class="col-md-12 d-flex gap-3 action-from justify-content-center">';
                        if (this.dataFromDynamicComponent.hasOwnProperty('newSr') && !this.dataFromDynamicComponent.hasOwnProperty('localstorage')) {
                            template += '<button  type="button" (click)="modifyscript($event)" data-toggle="tooltip" data-placement="top" title="This button enables you to change the Service Type and retail your contact and address details." class="btn btn-outline-primary submit-form modify"><i class="fas fa-redo mr-2">&nbsp;</i>Redo</button>';
                            template += '<button (click)="redoscript($event)" type="button" class="btn btn-outline-primary me-1 redo previous-btn-ico"><i class="bi bi-arrow-left">&nbsp;</i>Previous</button>';

                            template += '<button type="button"  data-toggle="tooltip" data-placement="top" title="Submit and open a new SR with pre filled contact & address details" (click)="submitForm($event)" class="btn btn-outline-primary submit-form submitcontinue"><i class="bi bi-save mr-2">&nbsp;</i>Submit & Continue</button>';
                        }
                        template += '<button (click)="submitForm($event)" type="button" class="btn btn-primary submit-form next-btn-ico">Submit <i class="bi bi-save ms-2 ">&nbsp;</i></button>';
                        template += '</div>';
                        template += '</div>';
                        template += '</form>';
                        this.createComponentFromRaw(template);
                        this.setObjectMetaData(this.objectMetaData);
                        // Fallback when page has no tab-view loadcomplete event.
                        this.clearsetTimeout.push(setTimeout(() => {
                            if (!this.formDomReady) {
                                this.markFormDomReady();
                            }
                        }, 500));
                    }
                }, 0));
            });
            this.subscriptions.push(loadSub);
        }
    }
    refresh(){
        this.ngOnDestroy();
        this.ngOnInit();
    }
    loadCompleted(data) {
        if (data.contentLoaded) {
            this.clearsetTimeout.push(setTimeout(() => {
                this.formDomReady = true;
                this.setObjectMetaData(this.objectMetaData);
            }, 0));
        }
    }
    getObjectMetaData() {
        this.metadata.getObjectMetaData(this.dataFromDynamicComponent.entityName).subscribe((data: any) => {
            this.objectMetaData = data;
            //console.log("Get Object MetaData", this.objectMetaData);
            const columnNames = Object.values(data.columnNames);
            columnNames.forEach(obj => {
                let objDetails: any = obj;
                let fieldName = this.dataFromDynamicComponent.entityName + '.' + objDetails.ColumnName;
                if (objDetails.Primary) {
                    $(".pane:visible [name='" + fieldName + "']").attr('readonly', 'readonly');
                }
                if (objDetails.Lookup) {
                    //$(".pane:visible [name='"+fieldName+"']").attr('readonly','readonly');
                }
                //if(objDetails.ColumnName == "incidentstatus"){
                //console.log('status',objDetails.ColumnName);
                //}
                if (objDetails.Datatype == "PickList") {
                   // console.log(objDetails);
                    if (objDetails.hasOwnProperty('pickListValues')) {
                        let sortable: any = [];
                        for (var it in objDetails.pickListValues.newIdValues) {
                            if (objDetails.pickListValues.newIdValues[it].active == true) {
                                let objSorted: any = {};
                                objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                                objSorted.option_value = it;
                                sortable.push(objSorted);
                            }
                        }
                        if (objDetails.ColumnName == "pregnancyoutcome") {
                            sortable.sort(this.standardService.SortByValue);
                        } else {
                            sortable.sort(this.standardService.SortByName);
                        }
                        let menuOption: string = '<option value=""></option>';
                        for (let x = 0; x < sortable.length; x++) {
                            menuOption += '<option value="' + sortable[x].option_value.replace('key_', '') + '">' + sortable[x].option_label + '</option>';
                        }
                        if (objDetails.Multiselect) {
                            $(".pane:visible [name='" + fieldName + "']").attr("multiple", 'multiple').addClass('multichosen');
                        }
                        $(".pane:visible [name='" + fieldName + "']").html(menuOption);
                        if ($(".pane:visible [name='" + fieldName + "']").attr('readonly')) {
                            $(".pane:visible [name='" + fieldName + "']").attr('disabled', 'disabled');
                        } else {
                            $(".pane:visible [name='" + fieldName + "']").removeAttr('disabled');
                        }
                    }
                    if (objDetails.Multiselect) {
                        $(".pane:visible [name='" + fieldName + "']").attr("multiple", 'multiple').addClass('multichosen');
                        if ($(".pane:visible [name='" + fieldName + "']").attr('readonly')) {
                            $(".pane:visible [name='" + fieldName + "']").attr('disabled', 'disabled');
                        } else {
                            $(".pane:visible [name='" + fieldName + "']").removeAttr('disabled');
                        }
                        // //console.log($(".pane:visible [name='"+fieldName+"']").data('width'));
                        $(".pane:visible .multichosen").chosen({ hide_results_on_select: false, width: $(".pane:visible [name='" + fieldName + "']").data('width') });
                    }
                }
            })
            this.maybeApplyFormDataToPreview();
            $(document).off('.preview_' + this.randomID);
        })
    }
    setObjectMetaData(data) {
        //console.log(data);
        const columnNames = Object.values(data.columnNames);
        columnNames.forEach(obj => {
            let objDetails: any = obj;
            let fieldName = this.dataFromDynamicComponent.entityName + '.' + objDetails.ColumnName;
            if (objDetails.Primary) {
                $(".pane:visible [name='" + fieldName + "']").attr('readonly', 'readonly');
            }
            if (objDetails.Lookup) {
                //$(".pane:visible [name='"+fieldName+"']").attr('readonly','readonly');
            }

            if (objDetails.Datatype == "PickList") {
                //console.log(objDetails);
                if (objDetails.hasOwnProperty('pickListValues')) {                   
                    let sortable: any = [];
                    for (var it in objDetails.pickListValues?.newIdValues) {
                        if (objDetails.pickListValues.newIdValues[it].active == true) {
                            if (objDetails.ColumnName == "incidentstatus") {
                                if (this.contextData?.payLoad?.incidentstatus == 103 ||
                                    JSON.parse(this.localStorageService.get('currentUser')).roles[0].id == '11' ||
                                    JSON.parse(this.localStorageService.get('currentUser')).roles[0].id == '5') {
                                    if (
                                        objDetails.pickListValues.newIdValues[it].value == 'Updated' ||
                                        objDetails.pickListValues.newIdValues[it].value == "Open"
                                    )
                                    {
                                        continue;
                                    }
                                }
                                else {

                                    if(objDetails.pickListValues.newIdValues[it].value == "Reopen" ||
                                    objDetails.pickListValues.newIdValues[it].value == 'Updated' ||
                                    objDetails.pickListValues.newIdValues[it].value == "Open") {
                                        continue;
                                    }
                                }
                            }
                            let objSorted: any = {};
                            objSorted.option_label = objDetails.pickListValues.newIdValues[it].value;
                            objSorted.option_value = it;
                            sortable.push(objSorted);
                        }

                    }
                    if (objDetails.ColumnName == "pregnancyoutcome") {
                        sortable.sort(this.standardService.SortByValue);
                    } else {
                        sortable.sort(this.standardService.SortByName);
                    }
                    let menuOption: string = '<option value=""></option>';
                    for (let x = 0; x < sortable.length; x++) {
                        menuOption += '<option value="' + sortable[x].option_value.replace('key_', '') + '">' + sortable[x].option_label + '</option>';
                    }
                    if (objDetails.Multiselect) {
                        $(".pane:visible [name='" + fieldName + "']").attr("multiple", 'multiple').addClass('multichosen');
                    }
                    $(".pane:visible [name='" + fieldName + "']").html(menuOption);
                    if ($(".pane:visible [name='" + fieldName + "']").attr('readonly')) {
                        $(".pane:visible [name='" + fieldName + "']").attr('disabled', 'disabled');
                    } else {
                        $(".pane:visible [name='" + fieldName + "']").removeAttr('disabled');
                    }
                }
                if (objDetails.Multiselect) {
                    $(".pane:visible [name='" + fieldName + "']").attr("multiple", 'multiple').addClass('multichosen');
                    if ($(".pane:visible [name='" + fieldName + "']").attr('readonly')) {
                        $(".pane:visible [name='" + fieldName + "']").attr('disabled', 'disabled');
                    } else {
                        $(".pane:visible [name='" + fieldName + "']").removeAttr('disabled');
                    }
                    // //console.log($(".pane:visible [name='"+fieldName+"']").data('width'));
                    $(".pane:visible .multichosen").chosen({ hide_results_on_select: false, width: $(".pane:visible [name='" + fieldName + "']").data('width') });
                }
            }
        })
        this.maybeApplyFormDataToPreview();
        this.applyMultiAccessFieldLocks();
    }
    expiredFlag = 0;
    
    setUIData(data) {        
        let self = this;        
        //this.loadingPrev = true;
        //console.log('Object Data',data);
        ////console.log("Get Object MetaData",this.objectMetaData);
        if (data?.payLoad) {
            if (data.payLoad.hasOwnProperty('expired')) {
                if (data.payLoad.expired && this.expiredFlag == 0) {
                    this.expiredFlag = 1;
                    Swal.fire('<span style="color:#f27474">Person expired</span>', '', '');
                }
            }

            if (data.entityName == "Triage") {
                this.standardService.emitData(data);
            }
            for (let i in data.payLoad) {
                let fieldName = this.dataFromDynamicComponent.entityName + '.' + i;

                if (this.objectMetaData) {
                    if (this.expiredFlag == 1) {
                        $("[data-uniquepageid='"+this.randomID+"'] [name='Person.expired']").prev().css({ "color": "red" });
                    }

                    if (!this.objectMetaData.columnNames.hasOwnProperty(i)) {
                        //Setting the data for parent object which will not have the datatype
                        
                        $("[data-uniquepageid='"+this.randomID+"'] [name^='" + fieldName + "']").each(function () {
                            fieldName = $(this).attr('name');
                            let array = fieldName.split('.');
                           // console.log('other object',fieldName);
                            
                            if(data.payLoad[i][array[array.length - 1]] == true || data.payLoad[i][array[array.length - 1]] == false){
                                $(this).val(data.payLoad[i][array[array.length - 1]].toString());
                            }else{
                                $(this).val(data.payLoad[i][array[array.length - 1]]);
                            }
                            if(data.payLoad[i][array[array.length - 1]] == "anonymous" || data.payLoad[i][array[array.length - 1]] == "Anonymous" || data.payLoad[i][array[array.length - 1]] == "anonymous@thesmartcity311.com"){
                                /* Readonly + values come from applyAnonymousContactMask on change — do not set here
                                 * (avoids extra readonly when Anonymous is toggled manually later). */
                                self.anonymousFromInitialPayload = true;
                                self.runAnonymousToggleFromPayload(self.randomID);
                            }                            
                        });
                    } else {
                        if (this.objectMetaData.columnNames[i].Datatype == "PickList") {
                           // console.log('Picklist',this.randomID);
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change');
                            $("[data-uniquepageid='"+this.randomID+"'] .multichosen").trigger('chosen:updated');
                        } else if (this.objectMetaData.columnNames[i].Datatype == "Boolean") {
                            ////console.log(fieldName);
                            let type = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('type');
                            if (type == 'checkbox') {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "'][value='" + data.payLoad[i].toString() + "']").prop('checked', true);
                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i].toString());
                            }

                        }
                        else if (i == 'updatedtime' || i == 'createdtime') {
                            //$(".pane:visible [name='" + fieldName + "']").text(this.standardService.convertToEST(data.payLoad[i]));
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.getDateTime(data.payLoad[i]));
                        } else if (this.objectMetaData.columnNames[i].Datatype == "Date") {
                            let attr: any = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('readonly');
                            ////console.log($(".pane:visible [name='"+fieldName+"']").attr('name')+'---'+attr);
                            if (!attr) {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.setDate(data.payLoad[i])).trigger('change');
                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.setDate(data.payLoad[i])).trigger('change');
                            }
                        } else if (this.objectMetaData.columnNames[i].Datatype == "DateTime") {
                            //console.log('est time ' + fieldName,this.standardService.getDateTime(data.payLoad[i]));
                            let attr: any = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('readonly');
                            if (!attr) {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.getDateTime(data.payLoad[i])).trigger('change');
                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.getDateTime(data.payLoad[i])).trigger('change');
                            }
                        } else if (this.objectMetaData.columnNames[i].Lookup) {
                            const vals: any = Object.values(data.payLoad[i]);
                            const keys: any = Object.keys(data.payLoad[i]);
                            if (vals.length > 0) {
                                for (let k in keys) {
                                    ////console.log(data.payLoad[i][p]+'-'+p);
                                    //if(p=='id'){

                                    $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "." + keys[k] + "']").val(data.payLoad[i][keys[k]]).trigger('change');
                                    //}
                                }

                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change');
                            }

                        }
                        else {
                            //added this for showing the value like tooltip for comment field & others which has more length value...
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('title', data.payLoad[i]);
                            //---------------------------------------------------------------------------
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change');
                        }
                    }
                }
            }
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.ngZone.run(() => this.refreshContactIdConcatDisplay(this.randomID));
                }, 0);
            });
            this.applyMultiAccessFieldLocks();
            // Re-apply after rules/picklist DOM updates settle.
            this.clearsetTimeout.push(setTimeout(() => this.applyMultiAccessFieldLocks(), 400));
        } else {
            //Swal.fire('Oops...', data.error, 'error');
        }
        //this.loadingPrev = false;
        //console.log('setting existing record');
        //$('.goog-te-combo').val('en');
        //setTimeout(()=>{
        //    $('.goog-te-combo').change();
        //this.changeLanguage($('.goog-te-combo').val());
        //},5000)        
        //alert($('.goog-te-combo').val());
    }
    setUIDataNewSr(data) {       
        let self = this;
       // console.log('Object Data', data);
        //console.log("Get Object MetaData",this.objectMetaData);
        if (data?.payLoad) {
            if (data.payLoad.hasOwnProperty('expired')) {
                if (data.payLoad.expired && this.expiredFlag == 0) {
                    this.expiredFlag = 1;
                    Swal.fire('<span style="color:#f27474">Person expired</span>', '', '');
                }
            }

            if (data.entityName == "Triage") {
                this.standardService.emitData(data);
            }
            for (let i in data.payLoad) {
                let fieldName = this.dataFromDynamicComponent.entityName + '.' + i;

                if (this.objectMetaData) {
                    if (this.expiredFlag == 1) {
                        $("[data-uniquepageid='"+this.randomID+"'] [name='Person.expired']").prev().css({ "color": "red" });
                    }

                    if (!this.objectMetaData.columnNames.hasOwnProperty(i)) {
                        //Setting the data for parent object which will not have the datatype
                        $("[data-uniquepageid='"+this.randomID+"'] [name^='" + fieldName + "']").each(function () {
                            fieldName = $(this).attr('name');
                            let array = fieldName.split('.');
                           // $(this).val(data.payLoad[i][array[array.length - 1]]);
                            if(data.payLoad[i][array[array.length - 1]] == true || data.payLoad[i][array[array.length - 1]] == false){
                                $(this).val(data.payLoad[i][array[array.length - 1]].toString());
                            }else{
                                $(this).val(data.payLoad[i][array[array.length - 1]]);
                            }
                            if(data.payLoad[i][array[array.length - 1]] == "anonymous" || data.payLoad[i][array[array.length - 1]] == "Anonymous" || data.payLoad[i][array[array.length - 1]] == "anonymous@thesmartcity311.com"){
                                self.anonymousFromInitialPayload = true;
                                self.runAnonymousToggleFromPayload(self.randomID);
                            }   
                        });
                    } else {
                        if (this.objectMetaData.columnNames[i].Datatype == "PickList") {
                            ////console.log('Picklist',fieldName+' '+data.payLoad[i]);
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change').addClass('changed');
                            $("[data-uniquepageid='"+this.randomID+"'] .multichosen").trigger('chosen:updated');
                        } else if (this.objectMetaData.columnNames[i].Datatype == "Boolean") {
                            ////console.log(fieldName);
                            let type = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('type');
                            if (type == 'checkbox') {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "'][value='" + data.payLoad[i].toString() + "']").prop('checked', true).addClass('changed');
                            } else {
                                // $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i].toString()).addClass('changed');
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i].toString()).trigger('change').addClass('changed');
                            }

                        }
                        else if (i == 'updatedtime' || i == 'createdtime') {
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").text(this.standardService.convertToEST(data.payLoad[i]));
                        } else if (this.objectMetaData.columnNames[i].Datatype == "Date") {
                            let attr: any = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('readonly');
                            ////console.log($(".pane:visible [name='"+fieldName+"']").attr('name')+'---'+attr);
                            if (!attr) {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.setDate(data.payLoad[i])).trigger('change').addClass('changed');
                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.setDate(data.payLoad[i])).trigger('change').addClass('changed');
                            }
                        } else if (this.objectMetaData.columnNames[i].Datatype == "DateTime") {
                            let attr: any = $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('readonly');
                            if (!attr) {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.getDateTime(data.payLoad[i])).trigger('change').addClass('changed');
                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(this.standardService.getDateTime(data.payLoad[i])).trigger('change').addClass('changed');
                            }
                        } else if (this.objectMetaData.columnNames[i].Lookup) {
                            const vals: any = Object.values(data.payLoad[i]);
                            const keys: any = Object.keys(data.payLoad[i]);
                            if (vals.length > 0) {
                                for (let k in keys) {
                                    ////console.log(data.payLoad[i][p]+'-'+p);
                                    //if(p=='id'){

                                    $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "." + keys[k] + "']").val(data.payLoad[i][keys[k]]).trigger('change').addClass('changed');
                                    //}
                                }

                            } else {
                                $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change').addClass('changed');
                            }

                        }
                        else {
                            //added this for showing the value like tooltip for comment field & others which has more length value...
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").attr('title', data.payLoad[i]);
                            //---------------------------------------------------------------------------
                            //f($("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").parents('.tab-pane'))
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).trigger('change').addClass('changed');
                            $("[data-uniquepageid='"+this.randomID+"'] [name='" + fieldName + "']").val(data.payLoad[i]).addClass('changed');
                        }
                    }
                }
            }
            //$('.pane:visible .dynamic-form').find('.submit-form').removeAttr('disabled');
            this.ngZone.runOutsideAngular(() => {
                setTimeout(() => {
                    this.ngZone.run(() => this.refreshContactIdConcatDisplay(this.randomID));
                }, 0);
            });
        } else {
            //Swal.fire('Oops...', data.error, 'error');
        }
    }
    
    randomId() {
        return Math.floor(Math.random() * (999 - 100 + 1) + 100) + Date.now();
    }
    randomID = this.randomId();
    changeLanguage(languageCode) {
        // Wait for the translation dropdown to be rendered
        //const interval = setInterval(function () {
          const translateDropdown:any = document.querySelector('.goog-te-combo');
         // console.log(translateDropdown);

          if (translateDropdown) {
            // Set the dropdown value to the selected language
            translateDropdown.value = languageCode;

            // Trigger the change event
            translateDropdown.dispatchEvent(new Event('change'));

            // Clear the interval once the dropdown is found
            //clearInterval(interval);
          }
       // }, 500); // Check every 500ms
      }
    // Here we create the component.
    private createComponentFromRaw(template: string) {
        // Use a static cache to avoid recompiling the same template
        let factory;
        if (PreviewComponent.templateFactoryCache.has(template)) {
            factory = PreviewComponent.templateFactoryCache.get(template);
        } else {
            @Component({
                template: `${template}`,
                styleUrls: []
            })
            class DynamicComponent implements OnInit, AfterContentInit, AfterViewInit {
                submitredoscript: boolean = false;
                constructor(
                    private agentScrService: AgentscriptService,
                    public _parent: PreviewComponent,
                    public spinner: SpinnerVisibilityService,
                    private objectcontroller: ObjectController,
                    private metadata: MetaData
                ) { }


                rule_condition = [];
                rule_then = [];
                rule_else = [];
                currentPage: any;
                pageRules = [];
                gotopage: boolean = false;
                viewed_pages = [];
                public checkFields: Object = { text: 'option_label', value: 'option_value' };
                public checkWaterMark: string = '--Select-- ';
                public popHeight: string = '350px';
                public mode = 'CheckBox';
                public filterPlaceholder = 'Search';
                disableValue = true;
                changeEventPayload: any = {};

                ngOnInit() {               
                }
                ngAfterViewInit() {
                    //Start Binding Rules
                    if (this._parent.step_form) {
                        this.currentPage = this._parent.step_form[0].id;
                        for (let pg in this._parent.step_form) {
                            //------------Single Page Rules Execution Start here---------------------
                            if (this._parent.step_form[pg].parentPageGroupId !== undefined) {
                                //console.log('PageRules Exec');   
                                $(document).off('.pane:visisble');
                                this.getPageRules(this._parent.step_form[pg].rules);
                            } else {
                                //-----------AgentScript Page Rules Execution Start here==================
                                this.getRules(this._parent.step_form[pg].id);
                                if (this._parent.step_form[pg].subGroupPages && this._parent.step_form[pg].subGroupPages.length > 0) {
                                    this.bindPageRules(this._parent.step_form[pg].subGroupPages);
                                }
                            }
                        }
                        //let user = JSON.parse(localStorage.getItem('currentUser'));

                    }
                    this._parent.clearsetTimeout.push(setTimeout(()=>{
                        // Guard against multiple inputmask initializations
                        const phoneInputs: any = $(
                            `[data-uniquepageid='${this._parent.randomID}'] input[name='Contact.phonenumber'],[data-uniquepageid='${this._parent.randomID}'] input[name='Contact.alternateph']`
                        ).filter(function (this: HTMLElement) {
                            return $(this).closest('.lookup_contact').length === 0;
                        });
                        phoneInputs.each(function () {
                            const $el = $(this);
                            if (!$el.data('inputmask-initialized')) {
                                ($el as any).inputmask('(999) 999-9999');
                                $el.data('inputmask-initialized', true);
                            }
                        });
                        // Initialize tooltips once per instance
                        const tooltipRoot = $(`[data-uniquepageid='${this._parent.randomID}']`);
                        if (!tooltipRoot.data('tooltips-initialized')) {
                            $('[data-toggle="tooltip"]').tooltip();
                            tooltipRoot.data('tooltips-initialized', true);
                        }
                        if(JSON.parse(this._parent.localStorageService.get('currentUser')).roles[0].authority == 'Department' ||
                            JSON.parse(this._parent.localStorageService.get('currentUser')).roles[0].authority == JSON.parse(this._parent.localStorageService.get('currentUser')).location.locationname
                         ){                        
                            $('[data-elementid="'+$(".hide-department").parent().attr('data-elementid')+'"]').remove();
                        }
                        const rid = this._parent.randomID;
                        const lock = () => this._parent.applyLookupContactFieldLock(rid);
                        lock();
                        this._parent.clearsetTimeout.push(
                            setTimeout(lock, 600),
                            setTimeout(lock, 1800)
                        );
                        if (this._parent.isFortWayneAdminRole()) {
                            $(document)
                                .off('click.contactLookup_' + rid)
                                .on('click.contactLookup_' + rid, `[data-uniquepageid='${rid}'] .lookup_contact`, (e) => {
                                    const el = e.target as HTMLElement;
                                    if (el.closest('button,a')) {
                                        return;
                                    }
                                    const mouseEv = (e.originalEvent || e) as MouseEvent;
                                    if (
                                        this._parent.contactLookupClickShouldIgnore(
                                            mouseEv,
                                            e.currentTarget as Element
                                        )
                                    ) {
                                        return;
                                    }
                                    e.preventDefault();
                                    e.stopPropagation();
                                    const $div = $(e.currentTarget);
                                    this._parent.ngZone.run(() =>
                                        this._parent.openContactLookupDialog(rid, $div)
                                    );
                                });
                        }
                    },200))




                }

                ngAfterContentInit() {
                    let self = this;
                    //End Binding Rules
                    //Set Date Format of generated Html
                    //   moment.updateLocale(moment.locale(), { invalidDate: "MM/dd/YYYY" });
                    //   $(document).on("change",".pane:visible input[type=date]", function() {
                    //       this.setAttribute(
                    //               "data-date",moment((<HTMLInputElement>this).value, "YYYY-MM-DD").format( "MM/DD/YYYY" )
                    //       )
                    //   }).trigger("change")
                   
                    //Smart Tab Functionality Start////////////
                    self._parent.ngZone.run(() => {
                        // Namespace for this instance
                        const tabclick = `.tabclick_${self._parent.randomID}`;   
                        // Remove any previous handlers for this instance
                        $(document).off(tabclick);
                        $(document).on("click"+tabclick, "[data-uniquepageid='"+self._parent.randomID+"'] [data-tabheadingid] li a", function () {                    
                            let elementid: any = $(this).parents('.smart-controls').data('elementid');
                            let titleid: any = $(this).data('tabtitleid');                        
                            $(`[data-uniquepageid='${self._parent.randomID}'] [data-tabheadingid='${elementid}'] li a`).removeClass('active');
                            $(`[data-uniquepageid='${self._parent.randomID}'] [data-tabcontentid='${elementid}'] [data-panelid]`).removeClass('active');
                            $(this).addClass('active');
                            $(`[data-uniquepageid='${self._parent.randomID}'] [data-panelid='${titleid}']`).find('[data-tabheadingid] li').eq(0).find('a').trigger('click');
                            $(`[data-uniquepageid='${self._parent.randomID}'] [data-panelid='${titleid}']`).addClass('active');
                            if (!$(`[data-uniquepageid='${self._parent.randomID}'] [data-panelid='${titleid}']`).find('[data-tabheadingid] li:visible').eq(0).find('a.nav-link').hasClass('active')) {                            
                                $(`[data-uniquepageid='${self._parent.randomID}'] [data-panelid='${titleid}']`).find('[data-tabheadingid] li:visible').find('a').trigger('click');
                            }                                           
                        })
                        
                        //Smart Tab Functionality End////////////
                        //Smart Accordion Functionality Start////////////
                        // $(document).on("click",".pane:visible .e-acrdn-header",function(){
                        //      let elementid:any = $(this).parents('[data-elementid]').data('elementid');
                        //      let titleid:any = $(this).data('tabtitleid');
                        //      $(`[data-accordionid='${elementid}'] .e-icons`).removeClass('e-expand-icon');
                        //      $(`[data-accordionid='${elementid}'] .e-acrdn-panel`).slideUp();
                        //      $(this).find('.e-icons').addClass('e-expand-icon');
                        //      $(`[data-panelid='${titleid}']`).slideDown();
                        //  })
                        //Smart Accordion Functionality End////////////
                        /* `data-uniquepageid` lives on the preview card *inside* `<form class="dynamic-form">`,
                         * so `[data-uniquepageid] form .smart-controls` never matched (no nested `form`). */
                        const smartFieldSelector =
                            `[data-uniquepageid='${self._parent.randomID}'] .smart-controls select, ` +
                            `[data-uniquepageid='${self._parent.randomID}'] .smart-controls input, ` +
                            `[data-uniquepageid='${self._parent.randomID}'] .smart-controls textarea`;
                        /* Scope by `data-uniquepageid` (not `.pane:visible`) so programmatic `change` from
                         * `setUIData` / hidden SR tabs still hits this handler. */
                        $(document).on("change"+tabclick+" keyup."+tabclick, smartFieldSelector, function (e) {
                            ////console.log("Changed event fire");
                            let changeEventElem: any = $(e.target);
                            if (
                                !changeEventElem.closest(
                                    `[data-uniquepageid='${self._parent.randomID}']`
                                ).length
                            ) {
                                return;
                            }

                            if (changeEventElem.attr('name') != undefined) {
                                const nmSync = (changeEventElem.attr('name') || '').toLowerCase();
                                if (
                                    e.type === 'change' &&
                                    nmSync.includes('.contactidobject.') &&
                                    (nmSync.endsWith('.firstname') || nmSync.endsWith('.lastname'))
                                ) {
                                    self._parent.refreshContactIdConcatDisplay(self._parent.randomID);
                                }
                                const anonToggleName = (changeEventElem.attr('name') || '').toLowerCase();
                                if(anonToggleName === 'anonymous'){
                                    /* `keyup` can run before `change` with a stale `checked` value — running
                                     * mask/restore on keyup corrupts state on the 2nd+ toggle (space/keyboard). */
                                    if (e.type !== 'change') {
                                        return;
                                    }
                                // console.log(self._parent.dataFromDynamicComponent.entityName,self._parent.contextData?.payLoad?.contactidobject);
                                    if(changeEventElem.prop('checked')){
                                        self._parent.applyAnonymousCheckedPipeline(
                                            self._parent.randomID
                                        );
                                    }else{
                                        self._parent.restoreContactFieldsWhenAnonymousUnchecked(
                                            self._parent.randomID
                                        );
                                        self._parent.applyLookupContactFieldLock(self._parent.randomID);
                                    }
                                }else{
                                // console.log(changeEventElem.closest('.tab-pane').siblings().length)
                                    changeEventElem.closest('.tab-pane.active').siblings().find('.changed').removeClass('changed')
                                    changeEventElem.addClass('changed');
                                    const classString = changeEventElem.parent().attr('class');
                                    const match = classString.split(' ').find(cls => cls.startsWith('concat.'));                                
                                    if (match) {
                                        const valueAfterDot = match.split('.')[1];  
                                        const state = 'IN';
                                        const country = 'United States (US)';
                                        const city = 'Fort Wayne';  
                                        $(`[data-uniquepageid='${self._parent.randomID}'] input[name]`).each(function () {
                                            const nameAttr = $(this).attr('name');
                                            
                                            if (nameAttr.endsWith(valueAfterDot)) {                                                                                        
                                            
                                                const street = $(`[data-uniquepageid='${self._parent.randomID}'] input[name='Incident.contactidobject.street']`).val();
                                                const zip = $(`[data-uniquepageid='${self._parent.randomID}'] input[name='Incident.contactidobject.postalcode']`).val();
                                                $(this).val(`${street} ${city} ${state} ${zip} ${country}`).addClass('changed');
                                            
                                            }
                                        });  

                                    }                                
                                }                        
                                if (self._parent.isMultiAccessLocation()
                                    && self._parent.dataFromDynamicComponent?.entityName === 'Incident'
                                    && !self._parent.dataFromDynamicComponent?.hasOwnProperty('newSr')) {
                                    $('.pane:visible .dynamic-form').find('.submit-form').attr('disabled', 'disabled');
                                } else {
                                    $('.pane:visible .dynamic-form').find('.submit-form').removeAttr('disabled');
                                }
                            }

                        })
                    });
                }

                redoscript(e) {
                   // console.log(this._parent.contextData.payLoad.tab.tab_id)
                    // //console.log("redo",$(".custom-tabs li.active").find("a").attr('data-obj-id'));
                    // //alert($("[data-obj-id='"+this._parent.breadcumbservice.idname+"']").length)
                    // var tabname=$(".custom-tabs li.active").find("a").attr('data-obj-id').slice(12, $(".custom-tabs li.active").find("a").attr('data-obj-id').length)
                    // //console.log(tabname )
                    $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().trigger('click');


                    // show/hide tabs
                    $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().show();
                    $("[data-obj-id='" + "incident-new" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().hide();



                    // $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").attr('data-obj-hide', 'show')
                    // $("[data-obj-id='" + "incident-new" + this._parent.contextData.payLoad.tab.tab_id + "']").attr('data-obj-hide', 'hide')

                    // $("[data-obj-id='"+this._parent.breadcumbservice.idname+"']").parent().trigger('click');
                    // this._parent.componentSelection.emit({ id: "incident-newww", name: 'Incident-newkhikhi', type: 'object'+this._parent.breadcumbservice.idname})
                }

                modifyscript(e) {
                   // console.log(this._parent.tab_title);
                    this._parent.agentscriptservice_updated.updateOrInsertArray(this._parent.tab_title,'modifyscript',true)
                    this._parent.agentscriptservice_updated.updateOrInsertArray(this._parent.tab_title,'searchterms','')

                    // serviceTypeInfo
                   // console.log(this._parent.contextData.payLoad.tab.tab_id)
                    $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().trigger('click');


                    // show/hide tabs
                    $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().show();
                    $("[data-obj-id='" + "incident-new" + this._parent.contextData.payLoad.tab.tab_id + "']").parent().hide();

                    // $("[data-obj-id='" + this._parent.contextData.payLoad.tab.tab_id + "']").attr('data-obj-hide', 'show')
                    // $("[data-obj-id='" + "incident-new" + this._parent.contextData.payLoad.tab.tab_id + "']").attr('data-obj-hide', 'hide')

                }
                refresh(){
                    this._parent.refresh();
                }
                print(){  
                                    
                    if(!$('.accordion-header').next().hasClass('show')){
                        $('.accordion-button').trigger('click');
                    }
                    this._parent.clearsetTimeout.push(setTimeout(()=>{    
                        $(".print-section").parents('.tab-pane >').addClass('print-section');   
                        let printid = $(".print-section").parents('.tab-pane').attr('data-elementid');
                        $("li[data-elementid="+printid+"] a").trigger('click');                 
                        window.print();
                    },200))
                }

                submitForm(e) {
                    let self = this;
                    if (self._parent.isMultiAccessLocation()
                        && self._parent.dataFromDynamicComponent?.entityName === 'Incident'
                        && !self._parent.dataFromDynamicComponent?.hasOwnProperty('newSr')) {
                        return false;
                    }
                    if(self._parent.dataFromDynamicComponent.entityName == 'Incident'){                           
                        if($("[data-uniquepageid='"+self._parent.randomID+"'] [name^='Incident.furtherdetails']").val() == "" 
                          || $("[data-uniquepageid='"+self._parent.randomID+"'] [name^='Incident.furtherdetails']").val() == undefined){                            
                            return false;
                        }
                    }                    
                    let currentElement = $(e.target);
                    currentElement.attr('disabled', 'disabled');
                    let submittedForm = currentElement.parents('.dynamic-form');
                    //self.changeEventPayload = {};
                    ////console.log(this._parent.standardService.serializeObject(submittedForm));
                    submittedForm.find('.changed').each(function (index, obj) {
                        let changeEventElem = $(obj);
                        const nameAttr = changeEventElem.attr('name');
                        if (!nameAttr) {
                            return;
                        }
                        let ev: string | number | string[] | undefined = changeEventElem.val() as any;
                        if (
                            self._parent.isContactIdObjectIdField(nameAttr) &&
                            changeEventElem[0] instanceof HTMLInputElement
                        ) {
                            ev = self._parent.readContactIdInputBackendValue(changeEventElem[0]);
                        }
                        if (ev != "" && ev != null && !(Array.isArray(ev) && ev.length === 0)) {
                            if (ev == "true" || ev == "false") {
                                self.changeEventPayload[nameAttr] = ev == "true";
                            } else if (!isNaN(ev as number)) {
                                self.changeEventPayload[nameAttr] = parseFloat(String(ev));
                            } else if (changeEventElem.attr('data-date-format')) {
                                if(changeEventElem.attr('type')=='date'){
                                    self.changeEventPayload[nameAttr] = self._parent.standardService.getTimeStampDate(String(ev));
                                }else if(changeEventElem.attr('type')=='datetime-local'){
                                    self.changeEventPayload[nameAttr] = self._parent.standardService.getTimeStampDateTime(String(ev));
                                }
                            } else {
                                self.changeEventPayload[nameAttr] = ev;
                            }
                        } else {
                            if (changeEventElem.hasClass('picklist')) {
                                self.changeEventPayload[nameAttr] = null;
                            } else {
                                self.changeEventPayload[nameAttr] = '';
                            }
                        }
                    })
                    //console.log(self._parent.dataFromDynamicComponent);
                    if (self._parent.dataFromDynamicComponent.id && !self._parent.dataFromDynamicComponent.hasOwnProperty('newSr') && (self._parent.dataFromDynamicComponent.actiontype == '' || !self._parent.dataFromDynamicComponent.hasOwnProperty('actiontype'))) {
                        //alert(self._parent.dataFromDynamicComponent.actionType);
                        self.changeEventPayload[this._parent.dataFromDynamicComponent.entityName + '.id'] = this._parent.dataFromDynamicComponent.id;
                        self.changeEventPayload[this._parent.dataFromDynamicComponent.entityName + '.updatedid'] = JSON.parse(this._parent.localStorageService.get('currentUser')).id;
                    } else {
                        self.changeEventPayload[this._parent.dataFromDynamicComponent.entityName + '.createdid'] = JSON.parse(this._parent.localStorageService.get('currentUser')).id;
                    }
                    //console.log(JSON.parse(this._parent.localStorageService.get('currentUser')).id);

                    //console.log(self.changeEventPayload);return false;
                   // console.log(self._parent.dataFromDynamicComponent)
                    if (self._parent.dataFromDynamicComponent.hasOwnProperty('newSr') && self._parent.dataFromDynamicComponent.newSr.entityName == "Incident") {
                        self.changeEventPayload['Incident.refno'] = self._parent.dataFromDynamicComponent.name
                        //self.changeEventPayload['Incident.contactid'] = self._parent.dataFromDynamicComponent.newSr.payLoad.contactid
                        self.changeEventPayload['Incident.incidenttypeworkspace'] = 196

                        // if(this._parent.agentscriptservice_updated.getIfAssociated(this._parent.tab_title).includes(true))
                        // {
                        //    // console.log(this._parent.agentscriptservice_updated.fetchData(this._parent.tab_title,'associateddata'))
                        //     self.changeEventPayload['Incident.parentid'] = this._parent.agentscriptservice_updated.fetchData(this._parent.tab_title,'associateddata').id
                        // }
                    }
                    var payload: any = {
                        "entityName": self._parent.dataFromDynamicComponent.entityName,
                        "payLoad": self.changeEventPayload
                    };
                    //console.log(payload);
                    ////// Extracting other object data && anonymous///
                    let dynamicObject:any = {};
                    dynamicObject.payLoad = {};   
                        for(let i in self.changeEventPayload) {                        
                            if(i && i.split('.').length == 3){   
                                let otherObjectDetails = JSON.parse(JSON.stringify(self.changeEventPayload));
                                for(let j in otherObjectDetails){
                                    //console.log(j);
                                    
                                    if(j.indexOf(i.split('.')[1]) >= 0){
                                        if(i.split('.')[1] == 'contactidobject'){ 
                                            //console.log(j,self.changeEventPayload[j]);                                                                                                                                                          
                                            dynamicObject.entityName = "Contact";                                        
                                            dynamicObject.payLoad[dynamicObject.entityName+'.'+j.split('.')[2]] = otherObjectDetails[j];
                                            const $cidIn = $("[data-uniquepageid='"+self._parent.randomID+"'] [name='"+i.split('.')[0]+'.'+i.split('.')[1]+'.id'+"']");
                                            const idRaw =
                                                $cidIn.length && $cidIn[0] instanceof HTMLInputElement
                                                    ? self._parent.readContactIdInputBackendValue($cidIn[0] as HTMLInputElement)
                                                    : String($cidIn.val() ?? '');
                                            dynamicObject.payLoad[dynamicObject.entityName+'.id'] = parseInt(idRaw, 10);                                        
                                        }else{

                                        }     
                                        //console.log(dynamicObject)                                                                                                              
                                        delete self.changeEventPayload[j];
                                    }
                                }
                            }
                        }       
                    ////  Extracting other object data && anonymous ///
                    if(self._parent.dataFromDynamicComponent.entityName == 'Incident'){
                        if (self._parent.dataFromDynamicComponent.hasOwnProperty('newSr')) {

                            ////console.log(self._parent.dataFromDynamicComponent.newSr.payLoad.contactidobject);
                            var newSrPayload = [];
                            var contactPayload = {};
                            var addfieldsPayload = {};
                            var cartPayload = {}

                            // removed contact object as we are adding contactid in incident payload
                            for (let i in self._parent.dataFromDynamicComponent.newSr.payLoad.contactidobject) {
                                contactPayload['Contact.' + i] = self._parent.dataFromDynamicComponent.newSr.payLoad.contactidobject[i];
                                contactPayload['Contact.id'] = self._parent.dataFromDynamicComponent.newSr.payLoad.contactid
                            }
                            // contactPayload['Contact.createdid'] = self._parent.localStorageService.get('id');
                            // //console.log("add fields empty?")
                            if (!(Object.keys(self._parent.dataFromDynamicComponent.newSr.payLoad.addfields).length === 0 && self._parent.dataFromDynamicComponent.newSr.payLoad.addfields.constructor === Object)) {
                                for (let i in self._parent.dataFromDynamicComponent.newSr.payLoad.addfields) {
                                    addfieldsPayload['Addfields.' + i] = self._parent.dataFromDynamicComponent.newSr.payLoad.addfields[i];
                                }
                                newSrPayload.push({ entityName: 'Addfields', payLoad: addfieldsPayload });
                            }

                            if (!(Object.keys(self._parent.dataFromDynamicComponent.newSr.payLoad.cart).length === 0 && self._parent.dataFromDynamicComponent.newSr.payLoad.cart.constructor === Object)) {
                                for (let i in self._parent.dataFromDynamicComponent.newSr.payLoad.cart) {
                                    cartPayload['Cart.' + i] = self._parent.dataFromDynamicComponent.newSr.payLoad.cart[i];
                                }
                                newSrPayload.push({ entityName: 'Cart', payLoad: cartPayload });
                            }

                            if(Object.keys(dynamicObject).length != 0 && (Object.keys(dynamicObject.payLoad).length != 0))  newSrPayload.push(dynamicObject);
                            else newSrPayload.push({ entityName: 'Contact', payLoad: contactPayload });

                            newSrPayload.push(payload);

                            payload = newSrPayload;
                            //console.log(newSrPayload)
                        }
                        else {    
                            //console.log("ssssddd",dynamicObject);
                            var newSrPayload = [];
                            if(Object.keys(dynamicObject).length != 0 && (Object.keys(dynamicObject.payLoad).length != 0))  newSrPayload.push(dynamicObject);
                            newSrPayload.push(payload);
                            payload = newSrPayload;
                        }
                    }                
                    
                    //console.log(payload);
                    //return false;
                    var errorArr = self.checkValidation(this.currentPage);
                    ////console.log(self.checkErrorCount(errorArr));

                    if (!self.checkErrorCount(errorArr)) {
                        //console.log('valid');
                        self.spinner.show();
                        let freezingTimer = setTimeout(() => {
                            //Fire http request
                            self._parent.apiservice.logFreeze();

                        }, 10000);
                        if(self._parent.dataFromDynamicComponent.entityName != 'Incident'){
                                self.objectcontroller.entityCreate(payload).subscribe((data: any) => {
                                    clearTimeout(freezingTimer);
                                    self.spinner.hide();
                                    //currentElement.removeAttr('disabled');
                                    if (data.error == null) {
                                        if(data.entityName=='Contact')
                                            {
                                                var saveAgentRecentAccesspayload={"contactid":data.payLoad.id}

                                                self._parent.standardService.saveAgentRecentAccess(saveAgentRecentAccesspayload).subscribe((data:any)=>{
                                                   // console.log(data)
                                                    self._parent.agentscriptservice_updated.agentrecentaccess()
                                                  })
                                            }
                                        //console.log(data);
                                        // Swal.fire('Success!', 'Saved successfully!', 'success');
                                        Swal.fire({
                                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Saved successfully!</div></div>',
                                            icon: 'success',
                                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                            imageHeight: 45,
                                            showCloseButton: true,
                                            showCancelButton: false,
                                            focusConfirm: false,
                                            confirmButtonText: `Ok`,
                                        })
                                        //Swal.fire('Success!', self._parent.dataFromDynamicComponent.name + " has been created.", 'success');
                                        //submittedForm[0].reset();
                                        if (data.entityName == "Triage") {
                                            self._parent.standardService.emitData(data);
                                        }

                                        self.objectcontroller.getObjectData(data.payLoad.id, self._parent.dataFromDynamicComponent.entityName).subscribe((result: any) => {
                                            
                                           // console.log(result);
                                            //if (self._parent.dataFromDynamicComponent.id && self._parent.dataFromDynamicComponent.id > 0) {
                                                self._parent.setUIData(result);
                                                self.changeEventPayload[self._parent.dataFromDynamicComponent.entityName + '.id'] = data.payLoad.id;
                                            //} else {

                                                // //    if(action){
                                                // let tempcomponentData = {
                                                //     id: data.payLoad.id,
                                                //     name: self._parent.dataFromDynamicComponent.entityName + '-' + data.payLoad.id,
                                                //     roleId: '',
                                                //     type: 'object',
                                                //     entityName: self._parent.dataFromDynamicComponent.entityName,
                                                // }
                                                // this._parent.componentSelection.emit(tempcomponentData);
                                                // //    }
                                            //}
                                        })
                                    } else {

                                        Swal.fire({
                                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                                            html:data,
                                            icon: 'error',
                                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                            imageHeight: 45,
                                            showCloseButton: true,
                                            showCancelButton: false,
                                            focusConfirm: false,
                                            confirmButtonText: `OK`,
                                            cancelButtonText: 'Cancel'
                                          })
                                        // Swal.fire('Oops...! <br>Something went wrong,Please try again. If problem persists please contact support.', data.error, 'error');
                                    }
                                });
                            //}
                        }else{
                            // const startTime = performance.now();
                            var timeout_ms=5000

                            self.objectcontroller.onSaveObject(payload).pipe(
                                timeout(timeout_ms), 
                                catchError(error => {
                                    // alert(error.name)
                                  if (error.name === 'TimeoutError') {
                                    self._parent.apiservice.getByIncidentByRefno(this._parent.tab_title).pipe(
                                        timeout(timeout_ms), 
                                        catchError(error => {
                                            // alert(error.name)
                                          if (error.name === 'TimeoutError') {
                                            
                                            Swal.fire({
                                                title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>Please try again<br>If problem persists please contact support.</div></div>',
                                                html:'',
                                                imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                imageHeight: 45,
                                                icon: 'error',
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                focusConfirm: false,
                                                confirmButtonText: `OK`,
                                                cancelButtonText: 'Cancel'
                                              })
                                            this._parent.refresh();                                       
                                            self.spinner.hide();
                                          }
                                            return ''
                                          })
                                    )
                                    .subscribe((data:any)=>{
                                       // console.log(data)
                                        if(data == null ) {
                                            
                                            Swal.fire({
                                                title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>Please try again<br>If problem persists please contact support.</div></div>',
                                                html:'',
                                                imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                imageHeight: 45,
                                                icon: 'error',
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                focusConfirm: false,
                                                confirmButtonText: `OK`,
                                                cancelButtonText: 'Cancel'
                                              })
                                            clearTimeout(freezingTimer);
                                            self.spinner.hide();

                                            this._parent.refresh()
                                          }
                                          else {
                                            //// console.log(this.recentincidents)
                                            self.spinner.hide();
                                            clearTimeout(freezingTimer);
                                            if (data.id) {
                                                var saveAgentRecentAccesspayload={"incidentid":data.id}
                                                self._parent.standardService.saveAgentRecentAccess(saveAgentRecentAccesspayload).subscribe((res:any)=>{
                                                  self._parent.agentscriptservice_updated.agentrecentaccess()
                                                })
                                            }
                                            this._parent.standardService.clearlocalStorage('servicepayload',self._parent.dataFromDynamicComponent.name)
                                                        this._parent.standardService.clearlocalStorage('tabdata',self._parent.dataFromDynamicComponent.name)

                                                        this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name) > -1 ? this._parent.agentscriptservice_updated.AlldataArray.splice(this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name), 1) : '';
                                                        console.log(this._parent.agentscriptservice_updated.AlldataArray)
                                                        
                                                        Swal.fire({
                                                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID:<span style="color:#275a8a"><u>'+this._parent.tab_title+"</span></u>"+'</div></div>',
                                                            icon: 'success',
                                                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                            imageHeight: 45,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            focusConfirm: false,
                                                            confirmButtonText: `OK`,
                                                        })
                                                        $("[data-closebutton-id='" + this._parent.tab_title+'-closebutton' + "']").trigger('click')
                                                        $("[data-obj-id='" + 'home' + "']").parent().trigger('click');
                                                        // this._parent.agentscriptservice_updated.getuserallnotifications()
                                                        // this._parent.agentscriptservice_updated.getusernotifications()
                                          }
                                    })
                                                               
                                    // return '';
                                  }
                                //   Swal.fire({
                                //     title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>Please try again<br>If problem persists please contact support.</div></div>',
                                //     html:'',
                                //     imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                //     imageHeight: 45,
                                //     icon: 'error',
                                //     showCloseButton: true,
                                //     showCancelButton: false,
                                //     focusConfirm: false,
                                //     confirmButtonText: `OK`,
                                //     cancelButtonText: 'Cancel'
                                //   })
                                // this._parent.refresh()
                                // self.spinner.hide();

                                  return '';  // Return an empty array or handle the error appropriately
                                })
                              ).subscribe((data: any) => {
                                // const duration = performance.now() - startTime; 
                                // alert(duration)
                                clearTimeout(freezingTimer);
                                self.spinner.hide();
                                //currentElement.removeAttr('disabled');
                                if (data) {
                                    //console.log(data)
                                    //console.log(self._parent.dataFromDynamicComponent)
                                    //console.log(self._parent.dataFromDynamicComponent.entityName)
                                    currentElement.attr('disabled', 'disabled');
                                    for (let i = 0; i < data.length; i++) {
                                        //console.log(data[i].entityName)
                                        //console.log(self._parent.dataFromDynamicComponent.entityName)

                                        //console.log(data[i])
                                        // data[i].entityName == self._parent.dataFromDynamicComponent.entityName &&
                                        if (data[i].error == null) {

                                            
                                            // //console.log(data[i].entityName)
                                            // //console.log(self._parent.dataFromDynamicComponent.entityName)
                                            //console.log(data[i].error)
                                            if (self._parent.dataFromDynamicComponent.id && !self._parent.dataFromDynamicComponent.hasOwnProperty('newSr') && (self._parent.dataFromDynamicComponent.actiontype == '' || !self._parent.dataFromDynamicComponent.hasOwnProperty('actiontype'))) {                                            
                                                if (data[i].entityName == "Incident") {
                                                   
                                                    // Swal.fire('Success!', "Service Request has been updated." , 'success');

                                                    Swal.fire({
                                                        title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >Service Request has been updated.</div></div>',
                                                        icon: 'success',
                                                        imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                        imageHeight: 45,
                                                        showCloseButton: true,
                                                        showCancelButton: false,
                                                        focusConfirm: false,
                                                        confirmButtonText: `OK`
                                                      })
                                                      $("[data-closebutton-id='" + this._parent.tab_title+'-closebutton' + "']").trigger('click')
                                                      $("[data-obj-id='" + 'home' + "']").parent().trigger('click');

                                                      
                                                }
                                            } else {
                                                if ((currentElement).hasClass('submitcontinue'))
                                                {
                                                    this.showAlertWithAction(self._parent.dataFromDynamicComponent.name)
                                                    this._parent.agentscriptservice_updated.savenotification(data[i].payLoad.id,self._parent.dataFromDynamicComponent.name,data[i].payLoad.departmentpicklist.id,data[i].payLoad.casetypepicklist.id)
                                                    if (data[i].entityName == "Incident") {
                                                        var saveAgentRecentAccesspayload={"incidentid":data[i].payLoad.id}
                                                        self._parent.standardService.saveAgentRecentAccess(saveAgentRecentAccesspayload).subscribe((data:any)=>{
                                                          self._parent.agentscriptservice_updated.agentrecentaccess()
                                                        })
                                                    }
                                                }
                                                else{
                                                    
                                                    if (data[i].entityName == "Incident") { 
                                                        
                                                        var saveAgentRecentAccesspayload={"incidentid":data[i].payLoad.id}
                                                        self._parent.standardService.saveAgentRecentAccess(saveAgentRecentAccesspayload).subscribe((data:any)=>{
                                                         // console.log(data)
                                                          self._parent.agentscriptservice_updated.agentrecentaccess()
                                                        })

                                                        // localStorage.setItem('servicepayload',"")                                               
                                                        // Swal.fire('Success!', "A New Service Request is submitted.<br> SR ID:" + " " + "<span style='color:#275a8a'><u>" + self._parent.dataFromDynamicComponent.name + '</span></u>', 'success');
                                                        this._parent.standardService.clearlocalStorage('servicepayload',self._parent.dataFromDynamicComponent.name)
                                                        this._parent.standardService.clearlocalStorage('tabdata',self._parent.dataFromDynamicComponent.name)

                                                        this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name) > -1 ? (this._parent.agentscriptservice_updated.AlldataArray.splice(this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name), 1),console.log('found and deleted')) : console.log(this._parent.agentscriptservice_updated.AlldataArray,self._parent.dataFromDynamicComponent.name,self._parent.dataFromDynamicComponent.name,' is not found');
                                                        console.log(self._parent.dataFromDynamicComponent.name,this._parent.agentscriptservice_updated.AlldataArray)

                                                        Swal.fire({
                                                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID:<span style="color:#275a8a"><u>'+self._parent.dataFromDynamicComponent.name+"</span></u>"+'</div></div>',
                                                            icon: 'success',
                                                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                            imageHeight: 45,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            focusConfirm: false,
                                                            confirmButtonText: `OK`,
                                                        })
                                                        $("[data-closebutton-id='" + this._parent.tab_title+'-closebutton' + "']").trigger('click')
                                                        $("[data-obj-id='" + 'home' + "']").parent().trigger('click');
                                                        
                                                        this._parent.agentscriptservice_updated.savenotification(data[i].payLoad.id,self._parent.dataFromDynamicComponent.name,data[i].payLoad.departmentpicklist.id,data[i].payLoad.casetypepicklist.id)

                                                        // this._parent.agentscriptservice_updated.getuserallnotifications()
                                                        // this._parent.agentscriptservice_updated.getusernotifications()

                                                    }else{   
                                                        this._parent.standardService.clearlocalStorage('tabdata',self._parent.dataFromDynamicComponent.name)                                                 
                                                        // Swal.fire('Success!', self._parent.dataFromDynamicComponent.name + " has been created.", 'success');
                                                        this._parent.standardService.clearlocalStorage('servicepayload',self._parent.dataFromDynamicComponent.name)
                                                        
                                                        this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name) > -1 ? this._parent.agentscriptservice_updated.AlldataArray.splice(this._parent.agentscriptservice_updated.AlldataArray.findIndex((x: any) => x.refno == self._parent.dataFromDynamicComponent.name), 1) : '';
                                                        console.log(this._parent.agentscriptservice_updated.AlldataArray)

                                                        Swal.fire({
                                                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID:<span style="color:#275a8a"><u>'+self._parent.dataFromDynamicComponent.name+"</span></u>"+'</div></div>',
                                                            icon: 'success',
                                                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                            imageHeight: 45,
                                                            showCloseButton: true,
                                                            showCancelButton: false,
                                                            focusConfirm: false,
                                                            confirmButtonText: `OK`,
                                                        })
                                                    }
                                                }
                                            }

                                            // submittedForm[0].reset();
                                            // $(".redo,.submitcontinue,.modify").hide();
                                            if (data[i].entityName == "Triage") {
                                                self._parent.standardService.emitData(data);
                                            }
                                            if (data[i].entityName == self._parent.dataFromDynamicComponent.entityName) {
                                                //console.log(self._parent.dataFromDynamicComponent)
                                                //console.log(data[i])
                                                //console.log(data)
                                                // //console.log(data.filter((x: any) => x.entityName == self._parent.dataFromDynamicComponent.entityName))
                                                // var incident = data.filter((x: any) => x.entityName == self._parent.dataFromDynamicComponent.entityName)
                                                // incident = incident[0]
                                                // //console.log(data.filter((x: any) => x.entityName == self._parent.dataFromDynamicComponent.entityName).payLoad)
                                                // self.objectcontroller.getObjectData(data[i].payLoad.id, self._parent.dataFromDynamicComponent.entityName).subscribe((result: any) => {
                                                //     //console.log(result);
                                                //     self._parent.setUIData(result);
                                                //     self.changeEventPayload[self._parent.dataFromDynamicComponent.entityName + '.id'] = data[i].payLoad.id;
                                                //     delete self.changeEventPayload[self._parent.dataFromDynamicComponent.entityName + '.createdid'];
                                                //     self.changeEventPayload[self._parent.dataFromDynamicComponent.entityName + '.updatedid'] = JSON.parse(this._parent.localStorageService.get('currentUser')).id;
                                                // })
                                                // if ((currentElement).hasClass('submitcontinue'))
                                                //     this.componentSelectionEmitter({ src: '../../assets/images/NewSRactive.svg', alt: 'New Service Request', text: 'New Service Request (SR)', selected: false, type: "configuredNewSR", id: "configuredNewSR", height: "24px" })
                                            }


                                        } else {
                                            // Swal.fire('Oops...! <br>Something went wrong,Please try again. If problem persists please contact support.', data[i].error, 'error');
                                            Swal.fire({
                                                title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong.<br>One or more field(s) exceed the size limit. Please click the Previous button and reduce the text length in the field(s).<br>If problem persists please contact support.</div></div>',
                                                html:data[i].error,
                                                imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                                imageHeight: 45,
                                                icon: 'error',
                                                showCloseButton: true,
                                                showCancelButton: false,
                                                focusConfirm: false,
                                                confirmButtonText: `OK`,
                                                cancelButtonText: 'Cancel'
                                              })
                                        }
                                    }

                                } else {
                                    // Swal.fire('Oops...! <br>Something went wrong,Please try again. If problem persists please contact support.', data.error, 'error');
                                    Swal.fire({
                                        title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                                        html:data.error,
                                        imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                        imageHeight: 45,
                                        icon: 'error',
                                        showCloseButton: true,
                                        showCancelButton: false,
                                        focusConfirm: false,
                                        confirmButtonText: `OK`,
                                        cancelButtonText: 'Cancel'
                                      })
                                }
                            }
                        );
                        }

                    } else {
                        // Swal.fire('Oops...!', 'Please check all the required fields and try again.', 'error');
                        Swal.fire({
                            title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/wrong.svg" class="animated-check" >Please check all the required fields and try again.</div></div>',
                            icon: 'error',
                            imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                            imageHeight: 45,
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                            confirmButtonText: `OK`,
                            cancelButtonText: 'Cancel'
                          }).then((result) => {
                            self._parent.refresh();                        
                        })
                    }


                }
                handleTimeout() {
                    alert('handleTimeout')
                }

                showAlertWithAction(name: any) {
                    this._parent.standardService.clearlocalStorage('servicepayload',name)
                    this._parent.standardService.clearlocalStorage('tabdata',name)
                    
                    Swal.fire({
                        title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/verified.svg" class="animated-check" >A New Service Request is submitted<br> SR ID:<span style="color:#275a8a"><u>'+name+"</span></u>"+'</div></div>',
                        icon: 'success',
                        showCloseButton: true,
                        imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                        imageHeight: 45,
                        showCancelButton: false,
                        focusConfirm: false,
                        confirmButtonText: `Ok`,
                      }).then((result) => {
                        // if (result.value) {
                            this._parent.agentscriptservice_updated.updateOrInsertArray(this._parent.tab_title,'submitandcontinue',true)
                            this._parent.agentscriptservice_updated.submitandcontinue=true;
                            // this._parent.agentscriptservice_updated.assign(this._parent.tab_title,true)
                            $("[data-closebutton-id='" + this._parent.tab_title+'-closebutton' + "']").trigger('click')
                            $('#mainListTab1').trigger('click');
                            //$("[data-obj-id='" + 'home' + "']").parent().trigger('click');
                            //this._parent.agentscriptservice_updated.getuserallnotifications()
                            //this._parent.agentscriptservice_updated.getusernotifications()

                        // }
                    });

                }



                bindPageRules(pages) {
                    for (let pg in pages) {
                        this.getRules(pages[pg].id);
                        if (pages[pg].subGroupPages && pages[pg].subGroupPages.length > 0) {
                            this.bindPageRules(pages[pg].subGroupPages);
                        }
                    }
                }
                checkPageRules(pageid) {
                    //console.log(pageid);
                    var self = this;

                    self.agentScrService.getScriptRules(pageid).subscribe(
                        (data: any) => {
                            //console.log(data);
                            self.pageRules = [];
                            for (let i in data) {
                                if (data[i].ruleType == "page") {
                                    self.pageRules.push(data[i].scriptRules);
                                }
                            }
                            if (self.pageRules.length == 0) {
                                $(".finish").show();
                            } else {
                                $(".finish").hide();
                            }
                            //console.log('Page Rules', self.pageRules);
                        }
                    )
                }
                getRules(pageid) {
                    //console.log(pageid);
                    var self = this;

                    self.agentScrService.getScriptRules(pageid).subscribe(
                        (data: any) => {
                            ////console.log(data);
                            self.pageRules = [];
                            for (let i in data) {
                                if (data[i].ruleType == "page") {
                                    self.pageRules.push(data[i].scriptRules);
                                }
                                ////console.log(data[i].scriptRules);
                                self.executeRules(data[i].scriptRules);
                            }
                        }
                    )
                }

                getPageRules(data) {
                    var self = this;
                    //setTimeout(() => {
                    for (let i in data) {
                        //self.pageRules.push(data[i].rulesinfo);
                        self.executeRules(data[i].rulesinfo);
                    }
                    //}, 200)
                }
                //////////////////////////Executing Rules//////////////////////////////////
                executeRules(ruledata) {
                    var self = this;
                    if (ruledata) {
                        for (let i in ruledata.trigger) {
                            // Namespace for this instance
                            const pcrules = `.pcrules_${self._parent.randomID}`;   
                            // Remove any previous handlers for this instance
                            $(document).off(pcrules);
                            var trigger = ruledata.trigger[i];
                            var element = $("[data-uniquepageid='"+self._parent.randomID+"'] [data-elementid='" + trigger.elementId + "']");
                            if (trigger.triggerType == TriggerType.PAGE_LOADED || trigger.triggerType == TriggerType.EDITOR_LOADS) {
                                //console.log(ruledata);
                                self.executeTriggerByElement(ruledata);
                            }
                            if (
                                trigger.triggerType == TriggerType.INPUT_SELECTED ||
                                trigger.triggerType == TriggerType.INPUT_CONTROL ||
                                trigger.triggerType == TriggerType.FIELD_CHANGES
                            ) {
                                self._parent.ngZone.run(() => {
                                    element.find('input[type=radio],input[type=checkbox],select,input[type=text]').on('change'+pcrules, function (e) {
                                        // //console.log($(this).val());
                                        self.executeTriggerByElement(ruledata);
                                    })
                                    element.find('input[type=text],textarea').on('keyup'+pcrules, function (e) {
                                        //console.log($(this).val());
                                        self.executeTriggerByElement(ruledata);
                                    })
                                })

                            }

                            if (trigger.triggerType == TriggerType.BUTTON_CLICKED) {
                                //console.log(trigger.elementId);
                                $("#" + trigger.elementId).on('click'+pcrules, function (e) {
                                    //console.log('Button Clicked');
                                    e.preventDefault();
                                    self.executeTriggerByElement(ruledata);
                                })
                            }
                            if (trigger.triggerType == TriggerType.IMAGE_CLICKED) {
                                //console.log(trigger.elementId);
                                $("#" + trigger.elementId).on('click'+pcrules, function (e) {
                                    //console.log('Image Clicked');
                                    self.executeTriggerByElement(ruledata);
                                })
                            }
                        }
                    }
                }

                executeTriggerByElement(ruledata) {
                    var self = this;
                    //self.gotopage = false;
                    self.rule_condition = ruledata.condition;
                    if (self.rule_condition.length > 0) {
                        ////console.log(self.callCondition(self.rule_condition));
                        if (self.callCondition(self.rule_condition)) {
                            self.rule_then = ruledata.thenAction;
                            self.callThen(self.rule_then);
                        } else {
                            self.rule_else = ruledata.elseAction;
                            self.callElse(self.rule_else);
                        }
                    } else {
                        self.rule_then = ruledata.thenAction;
                        self.callThen(self.rule_then);
                    }
                }

                callCondition(condition) {
                    var self = this;
                    ////console.log(condition);
                    return self.checkConditions(condition, '');
                }
                evaluate(rules) {
                    var self = this;
                    if (rules.operator == 'equals') {
                        return self.evaluateEquals(rules);
                    }
                    if (rules.operator == 'is null') {
                        return self.evaluateIsNull(rules);
                    }
                    if (rules.operator == "is not null") {
                        return self.evaluateIsNotNull(rules);
                    }
                    if (rules.operator == "not equals (exclude No Value)") {
                        return self.evaluateNotEqualsExcludeNoValue(rules);
                    }
                    if (rules.operator == "not equals (include No Value)") {
                        return self.evaluateNotEqualsIncludeNoValue(rules);
                    }
                    if (rules.operator == "in list") {
                        return self.evaluateInList(rules);
                    }
                    if (rules.operator == "not in list") {
                        return self.evaluateNotInList(rules);
                    }
                    if (rules.operator == "like") {
                        return self.evaluateLike(rules);
                    }
                }
                evaluateLike(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (rules.value.search(element.find('input:checked').val()) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {
                        if (rules.value.search(element.find('select').val()) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        if (rules.value.search(element.find('input').val()) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateNotEqualsIncludeNoValue(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    var textarea = element.find('textarea');
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (element.find('input:checked').val() != rules.value || element.find('input:checked').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {

                        if (element.find('select').val() != rules.value || element.find('select').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        if (element.find('input').val() != rules.value || element.find('input').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (textarea.length > 0) {
                        if (element.find('textarea').val() != rules.value || element.find('textarea').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateNotInList(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    if (inputType == "radio" || inputType == "checkbox") {
                        let v: any;
                        if (isNaN(element.find('input:checked').val())) {
                            v = element.find('input:checked').val();
                        } else {
                            v = parseInt(element.find('input:checked').val());
                        }
                        if (rules.value.indexOf(v) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {
                        let v: any;
                        if (isNaN(element.find('select').val())) {
                            v = element.find('select').val();
                        } else {
                            v = parseInt(element.find('select').val());
                        }
                        if (rules.value.indexOf(v) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateInList(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    if (inputType == "radio" || inputType == "checkbox") {
                        let v: any;
                        if (isNaN(element.find('input:checked').val())) {
                            v = element.find('input:checked').val();
                        } else {
                            v = parseInt(element.find('input:checked').val());
                        }
                        if (rules.value.indexOf(v) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {
                        let v: any;
                        if (isNaN(element.find('select').val())) {
                            v = element.find('select').val();
                        } else {
                            v = parseInt(element.find('select').val());
                        }
                        if (rules.value.indexOf(v) >= 0) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateIsNull(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    var textarea = element.find('textarea');
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (element.find('input:checked').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {

                        if (element.find('select').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        if (element.find('input').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (textarea.length > 0) {
                        if (element.find('textarea').val() == "") {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateIsNotNull(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    var textarea = element.find('textarea');
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (element.find('input:checked').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {

                        if (element.find('select').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        if (element.find('input').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (textarea.length > 0) {
                        if (element.find('textarea').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateNotEqualsExcludeNoValue(rules) {
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    var textarea = element.find('textarea');
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (element.find('input:checked').val() != rules.value) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {

                        if (element.find('select').val() != rules.value) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        if (element.find('input').val() != rules.value) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (textarea.length > 0) {
                        if (element.find('textarea').val() != rules.value) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                evaluateEquals(rules) {
                    ////console.log(rules);
                    var self = this;
                    var element = $(".pane:visible [data-pageid] [data-elementid='" + rules.elementId + "']");
                    var inputType = element.find('input').attr('type');
                    var selectType = element.find('select');
                    var textarea = element.find('textarea');
                    var button = $("#" + rules.elementId);
                    if (inputType == "radio" || inputType == "checkbox") {
                        if (rules.value == element.find('input:checked').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (selectType.length > 0) {

                        if (rules.value == element.find('select').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (inputType == "text") {
                        ////console.log(rules);
                        ////console.log(element.find('input').val())
                        if (rules.value == element.find('input').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    if (textarea.length > 0) {
                        if (rules.value == element.find('textarea').val()) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                    return 0;
                }
                checkConditions(da, symbol) {
                    var evaluation = [];
                    var result;
                    for (var rc = 0; rc < da.length; rc++) {
                        var cond = da[rc];
                        symbol = cond.conditionExpression;
                        ////console.log(symbol);
                        for (var rls = 0; rls < cond.rules.length; rls++) {
                            if (cond.rules[rls].rules) {
                                var rlAr = [];
                                rlAr.push(cond.rules[rls]);
                                evaluation.push(this.checkConditions(rlAr, symbol));
                                //checkConditions(rlAr,symbol);
                            }
                            else {
                                evaluation.push(this.evaluate(cond.rules[rls]));
                            }
                        }
                        if (symbol == "AND") {
                            result = true;
                            for (var index = 0; index < evaluation.length; index++) {
                                if (evaluation[index] == 0) {
                                    result = false;
                                    break;
                                }
                            }
                        }
                        if (symbol == "OR") {
                            result = false;
                            for (var index = 0; index < evaluation.length; index++) {
                                if (evaluation[index] == 1) {
                                    result = true;
                                    break;
                                }
                            }
                        }
                        if (symbol == "")
                            result = evaluation[0];
                        ////console.log(evaluation);
                        ////console.log(symbol);
                        return result;
                    }
                }
                callThen(data) {
                    var self = this;
                    ////console.log("Then",data);
                    for (let t in data) {
                        var element = $("[data-uniquepageid='"+self._parent.randomID+"'] [data-elementid=" + data[t].elementId + "]");

                        if (data[t].actionType == ActionType.THEN) {
                            if (data[t].actionRule == ActionRulesType.HIDE_FIELD || data[t].actionRule == ActionRulesType.HIDE_OBJECT) {
                                ////console.log(element);
                                if (element.parent('.e-acrdn-content').length > 0) {
                                    element.parents('.e-acrdn-item').hide();
                                } else {
                                    element.hide();
                                }
                            }
                            if (data[t].actionRule == ActionRulesType.SHOW_FIELD || data[t].actionRule == ActionRulesType.SHOW_OBJECT) {
                                if (element.parent('.e-acrdn-content').length > 0) {
                                    element.parents('.e-acrdn-item').show();
                                } else {
                                    $("[data-uniquepageid='"+self._parent.randomID+"'] [data-tabtitleid=" + 's-' + data[t].elementId + "]").trigger('click');
                                    element.show();
                                }
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_REQUIRED) {
                                element.addClass('required');
                                //element.find('label').addClass('active-error');
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_OPTIONAL) {
                                element.removeClass('required');
                                element.find('label').removeClass('active-error');
                            }
                            if (data[t].actionRule == ActionRulesType.SET_FIELD_VALUE || data[t].actionRule == ActionRulesType.SET_INPUT_VALUE) {
                                if (data[t].value == "no_value") {
                                    //this.changeEventPayload[element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('name')] = null;
                                    element.find('input[type=text],select,textarea').val("");
                                    element.find('input[type=radio],input[type=checkbox]').prop('checked', false).trigger('change');
                                } else {
                                    //this.changeEventPayload[element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('name')] = data[t].value;
                                    element.find('input[type=text],select,textarea').val(data[t].value);
                                    element.find('input[type=radio],input[type=checkbox]').filter('[value="' + data[t].value + '"]').prop('checked', true);
                                }
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').addClass('changed');
                            }
                            if (data[t].actionRule == ActionRulesType.DISPLAY_MESSAGE) {
                                // Swal.fire(data[t].value, "", "info");
                                Swal.fire({
                                    title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                                    html:data[t].value,
                                    imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                    imageHeight: 45,
                                    icon: 'info',
                                    showCloseButton: true,
                                    showCancelButton: false,
                                    focusConfirm: false,
                                    confirmButtonText: `OK`,
                                    cancelButtonText: 'Cancel'
                                  })
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_EDITABLE) {
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').removeAttr('readonly');
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_READONLY) {
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('readonly', '');
                            }
                        }
                        if (data[t].goToPageType == GoToPageTypes.CERTAIN) {
                            //console.log('Go to page Called');
                            self.gotopage = true;
                            var errorArr = self.checkValidation(self.currentPage);
                            if (!self.checkErrorCount(errorArr)) {
                                //console.log('valid');
                                self.checkPageRules(data[t].goToPageId);
                                self.viewed_pages.push(data[t].goToPageId);
                                $(".pane:visible [data-pageid]").removeClass('active').hide();
                                $(".pane:visible [data-pageid=" + data[t].goToPageId + "]").addClass('active visited').show();
                            } else {
                                //console.log('Invalid');
                            }
                        }
                        if (data[t].goToPageType == GoToPageTypes.PREVIOUS) {
                            //console.log('Previous Page Called');
                            var currentPageid = $('.pane:visible [data-pageid].active').attr("data-pageid");
                            var currentPageParentid = $('.pane:visible [data-pageid].active').attr("data-parentid");
                            self.previous('', currentPageid, currentPageParentid);
                        }
                        if (data[t].goToPageType == GoToPageTypes.NEXT) {
                            //console.log('Next Page Called');
                            self.gotopage = true;
                            var currentPageid = $('.pane:visible [data-pageid].active').attr("data-pageid");
                            var currentPageParentid = $('.pane:visible [data-pageid].active').attr("data-parentid");
                            var errorArr = self.checkValidation(pageid);
                            if (!self.checkErrorCount(errorArr)) {
                                if (currentPageParentid) {
                                    //console.log("parent is there");
                                    var index = $('.pane:visible [data-parentid="' + currentPageParentid + '"].active').index('[data-parentid="' + currentPageParentid + '"]');
                                    var nextIndex = index + 1;
                                    if (nextIndex < $('.pane:visible [data-parentid="' + currentPageParentid + '"]').length) {
                                        $(".pane:visible [data-pageid]").removeClass('active').hide();
                                        var pageid = $('.pane:visible [data-parentid="' + currentPageParentid + '"]').eq(nextIndex).data('pageid');
                                        self.checkPageRules(pageid);
                                        self.viewed_pages.push(pageid);
                                        $('.pane:visible [data-parentid="' + currentPageParentid + '"]').eq(nextIndex).addClass('active visited').show();

                                    } else {
                                        $(".pane:visible .finish").show();
                                    }
                                } else {
                                    //console.log("parent is not there");
                                    var index = $('.pane:visible [data-pageid].script.active').index('[data-pageid].script');
                                    var nextIndex = index + 1;
                                    if (nextIndex < $('.pane:visible [data-pageid].script').length) {
                                        $(".pane:visible [data-pageid]").removeClass('active').hide();
                                        var pageid = $('.pane:visible [data-pageid].script').eq(nextIndex).data('pageid');
                                        self.checkPageRules(pageid);
                                        self.viewed_pages.push(pageid);
                                        $('.pane:visible [data-pageid].script').eq(nextIndex).addClass('active visited').show();
                                    } else {
                                        $(".pane:visible .finish").show();
                                    }
                                }
                            } else {
                                //console.log('Invalid');
                            }
                        }
                        if (data[t].goToPageType == GoToPageTypes.BEGINING) {
                            //console.log('Beginning Page Called');
                            self.beginning('');
                        }
                    }
                }

                callElse(data) {
                    let self = this;
                    ////console.log("Else",data);
                    for (let t in data) {
                        var element = $("[data-uniquepageid='"+self._parent.randomID+"'] [data-elementid=" + data[t].elementId + "]");
                        if (data[t].actionType == ActionType.ELSE) {
                            if (data[t].actionRule == ActionRulesType.HIDE_FIELD || data[t].actionRule == ActionRulesType.HIDE_OBJECT) {
                                if (element.parent('.e-acrdn-content').length > 0) {
                                    element.parents('.e-acrdn-item').hide();
                                } else {
                                    element.hide();
                                }
                            }
                            if (data[t].actionRule == ActionRulesType.SHOW_FIELD || data[t].actionRule == ActionRulesType.SHOW_OBJECT) {
                                if (element.parent('.e-acrdn-content').length > 0) {
                                    element.parents('.e-acrdn-item').show();
                                } else {
                                    $("[data-uniquepageid='"+self._parent.randomID+"'] [data-tabtitleid=" + 's-' + data[t].elementId + "]").trigger('click');
                                    element.show();
                                }
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_REQUIRED) {
                                element.addClass('required');
                                //element.find('label').addClass('active-error');
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_OPTIONAL) {
                                element.removeClass('required');
                                element.find('label').removeClass('active-error');
                            }
                            if (data[t].actionRule == ActionRulesType.SET_FIELD_VALUE || data[t].actionRule == ActionRulesType.SET_INPUT_VALUE) {
                                if (data[t].value == "no_value") {
                                    //this.changeEventPayload[element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('name')] = null;
                                    element.find('input[type=text],select,textarea').val("");
                                    element.find('input[type=radio],input[type=checkbox]').prop('checked', false).trigger('change');
                                } else {
                                    //this.changeEventPayload[element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('name')] = data[t].value;
                                    element.find('input[type=text],select,textarea').val(data[t].value);
                                    element.find('input[type=radio],input[type=checkbox]').filter('[value="' + data[t].value + '"]').prop('checked', true);
                                }
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').addClass('changed');
                            }
                            if (data[t].actionRule == ActionRulesType.DISPLAY_MESSAGE) {
                                // Swal.fire(data[t].value, "", "info");
                                Swal.fire({
                                    title: '<div class="popup-content"><div class="popup-text"> <img src="../../assets/images/warning.svg" class="animated-check" >Something went wrong,Please try again. If problem persists please contact support.</div></div>',
                                    html:data[t].value,
                                    icon: 'info',
                                    imageUrl: "https://fortwayne-portal.thesmartcity311.com/assets/images/fortwayne-logo-agent.svg",
                                    imageHeight: 45,
                                    showCloseButton: true,
                                    showCancelButton: false,
                                    focusConfirm: false,
                                    confirmButtonText: `OK`,
                                    cancelButtonText: 'Cancel'
                                  })
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_EDITABLE) {
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').removeAttr('readonly');
                            }
                            if (data[t].actionRule == ActionRulesType.FIELD_READONLY) {
                                element.find('input[type=text],select,textarea,input[type=radio],input[type=checkbox]').attr('readonly', '');
                            }
                        }
                    }
                }
                checkValidation(pageid) {
                    var self = this;
                    var error = [];

                    $(".pane:visible [data-pageid='" + pageid + "'] .smart-controls.required:visible").each(function () {
                        var inputType = $(this).find('input').attr('type');
                        var select = $(this).find('select');
                        if (inputType == "radio" || inputType == "checkbox") {
                            if ($(this).find('input').is(":checked") == false) {
                                error.push(1);
                                $(this).children('label').addClass('active-error');
                                $(this).find('input').addClass('active-error');
                            } else {
                                // //console.log('radio')
                                error.push(0);
                                $(this).children('label').removeClass('active-error');
                                $(this).find('input').removeClass('active-error');
                            }
                        }
                        if (inputType == "text" || inputType == "date") {
                            if ($(this).find('input').val() == '') {
                                error.push(1);
                                $(this).children('label').addClass('active-error');
                                $(this).find('input').addClass('active-error');
                            } else {
                                // //console.log('text')
                                error.push(0);
                                $(this).children('label').removeClass('active-error');
                                $(this).find('input').removeClass('active-error');
                            }
                        }
                        if (select.length > 0) {
                            if (select.val() == '') {
                                error.push(1);
                                $(this).children('label').addClass('active-error');
                                select.addClass('active-error');
                            } else {
                                error.push(0);
                                $(this).children('label').removeClass('active-error');
                                select.removeClass('active-error');
                            }
                        }
                    })
                    $(".pane:visible [data-pageid='" + pageid + "'] .smart-controls:visible").each(function () {
                        let inputType: any = $(this).find('input').attr('data-texttype');
                        let inputVal: any = $(this).find('input').val();
                        if (inputType == "Email") {
                            if (inputVal != "") {
                                if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(inputVal)) {
                                    //console.log('True Email');
                                    error.push(0);
                                    $(this).children('label').removeClass('active-error');
                                } else {
                                    //console.log('False Email');
                                    error.push(1);
                                    $(this).children('label').addClass('active-error');
                                }
                            } else {
                                error.push(0);
                                $(this).children('label').removeClass('active-error');
                            }
                        }
                    })
                    return error;
                }
                checkErrorCount(arr) {
                    var counts = {};
                    for (var i = 0; i < arr.length; i++) {
                        var num = arr[i];
                        counts[num] = counts[num] ? counts[num] + 1 : 1;
                    }
                    return counts[1];
                }
                previous(e, pageid, parentid) {
                    //console.log(pageid);
                    var self = this;
                    $(".pane:visible .finish").hide();
                    this.gotopage = false;
                    //console.log(self.viewed_pages);
                    if (self.viewed_pages.length > 1) {
                        self.viewed_pages.pop();
                        let prevPageId = self.viewed_pages[self.viewed_pages.length - 1];
                        //console.log(prevPageId);
                        $(".pane:visible [data-pageid]").removeClass('active').hide();
                        $(".pane:visible [data-pageid=" + prevPageId + "]").addClass('active').show();
                        $(".pane:visible [data-pageid=" + pageid + "]").removeClass('visited');
                    }
                }
                next(e, pageid, parentid) {
                    var self = this;
                    //console.log(pageid);
                    this.currentPage = pageid;
                    this._parent.clearsetTimeout.push(setTimeout(() => {
                        //console.log(self.gotopage);
                        if (!self.gotopage) {
                            var errorArr = self.checkValidation(pageid);
                            if (!self.checkErrorCount(errorArr)) {
                                //console.log('valid');
                                //Checking for next page is exist of the current root page element
                                if ($(".pane:visible [data-pageid=" + pageid + "]").next().length > 0) {
                                    var currentIndex = $('.pane:visible [data-pageid].rootpage.active').index(".rootpage");
                                    var i = currentIndex + 1;
                                    var nextpageid = $('.pane:visible [data-pageid].rootpage').eq(i).data('pageid');
                                    if (nextpageid) {
                                        //console.log('next');
                                        self.viewed_pages.push(nextpageid);
                                        //self.getRules(nextpageid);
                                        $('.pane:visible [data-pageid]').removeClass('active').hide();
                                        $(".pane:visible [data-pageid=" + nextpageid + "]").addClass('active visited').show();
                                        //Showing finish button if any element is exist of the current root page element
                                        if ($(".pane:visible [data-pageid=" + nextpageid + "]").next().length > 0) {
                                            //console.log("Exist");
                                            $(".pane:visible .finish").hide();
                                        } else {
                                            //console.log("Final");
                                            $(".pane:visible .finish").show();
                                        }
                                    }
                                }
                            } else {
                                //console.log('Invalid');
                            }
                        }
                    }, 200))
                }
                finish(e, scriptid, pageid) {
                    var self = this;
                    var errorArr = self.checkValidation(pageid);
                    if (!self.checkErrorCount(errorArr)) {
                        alert('Submitted');
                        //console.log($('#agentscriptform').serializeArray());
                    } else {
                        alert('Please check all the error,then click finish.');
                    }
                }
                beginning(e) {
                    var self = this;
                    self.gotopage = false;
                    this.currentPage = this._parent.step_form[0].id;
                    $(".pane:visible .finish").hide();
                    $('.pane:visible [data-pageid]').removeClass('active visited').hide();
                    $('.pane:visible [data-pageid].rootpage').eq(0).addClass('active visited').show();
                    self.clearPageForm();
                    //self.getRules(this.currentPage);
                }
                clearPageForm() {
                    (<HTMLFormElement>$('#agentscriptform')[0]).reset();
                    $('.pane:visible [data-pageid]').find('input[type=radio],input[type=checkbox],select').trigger('change');
                    $('.pane:visible [data-pageid]').find('input[type=text],textarea').trigger('keyup');
                }

                public componentSelectionEmitter(componentData: object) {
                    ////console.log(componentData);
                    this._parent.componentSelection.emit(componentData);
                }
                public loadCompleted(data: object) {
                    ////console.log(data);
                    this._parent.loadCompleted(data);
                    this.ngAfterViewInit();

                }

                buttonAction(e, action) {
                    if (action) {
                        let componentData = {
                            id: '',
                            name: 'New ' + action + '-' + this._parent.dataFromDynamicComponent.id,
                            roleId: '',
                            type: 'object',
                            entityName: action,
                            personid: this._parent.dataFromDynamicComponent.id
                        }
                        this._parent.componentSelection.emit(componentData);
                    }
                }
                ngOnDestroy() {
                    // Dispose tooltips, input masks, and chosen to prevent leaks
                    try {
                        const root = $(`[data-uniquepageid='${this._parent.randomID}']`);
                        root.find('[data-toggle="tooltip"]').tooltip('dispose');
                        root.find("input").each(function(){
                            const $el = $(this);
                            if ($el.data('inputmask-initialized')) {
                                try { ($el as any).inputmask('remove'); } catch {}
                                $el.removeData('inputmask-initialized');
                            }
                        });
                        root.find('.multichosen').each(function(){
                            try { ($(this) as any).chosen('destroy'); } catch {}
                        });
                    } catch {}
                    // Unbind any namespaced handlers for this instance
                    $(document).off(`.tabclick_${this._parent.randomID}`);
                    $(document).off(`.pcrules_${this._parent.randomID}`);
                }
            }
            @NgModule({
                imports: [
                    CommonModule,
                    // BrowserModule,
                    FormsModule,
                    ReactiveFormsModule,
                    NgbModule,
                    ReportViewModuleModule,
                    TabViewModuleModule,
                    TrackingViewModuleModule,
                    //BabyStatusConditionsModule,
                    AngularMultiSelectModule,
                    //ProgressBarModule,
                    QueryBuilderViewModuleModule,
                    //CardViewModule,
                    NoteModuleModule,
                    AttachmentsViewModuleModule,
                    //FroalaEditorModule.forRoot(),
                ],
                declarations: [DynamicComponent]
            }) class dynamicModule { };

            const mod = this.compiler.compileModuleAndAllComponentsSync(dynamicModule);
            factory = mod.componentFactories.find((comp) =>
                comp.componentType === DynamicComponent
            );
            PreviewComponent.templateFactoryCache.set(template, factory);
            // Cap cache size to prevent unbounded growth
            if (PreviewComponent.templateFactoryCache.size > 20) {
                const firstKey = PreviewComponent.templateFactoryCache.keys().next().value;
                PreviewComponent.templateFactoryCache.delete(firstKey);
            }
        }
        this.cmpRef = this.modalBody.createComponent(factory);
        this.components.push(this.cmpRef);
    }

    // Cleanup properly. You can add more cleanup-related stuff here.
    ngOnDestroy() {
        if (this.cmpRef) {
            this.cmpRef.destroy();
        }
        // Destroy any other dynamically created components
        if (this.components && this.components.length) {
        this.components.forEach((c:any) => {
            try { c.destroy(); } catch {}
        });
        this.components = [];
        }
        $(document).off('.tabclick_' + this.randomID);
        $(document).off('.pcrules_' + this.randomID);
        //$(document).off('.pane:visisble');                  
        // Unsubscribe from all subscriptions
        this.subscriptions.forEach(sub => sub.unsubscribe());
        this.subscriptions = [];        
        this.clearsetTimeout.forEach(clr => clearTimeout(clr));
        // Additional cleanup to prevent leaks
        try {
            const root = $(`[data-uniquepageid='${this.randomID}']`);
            root.find('[data-toggle="tooltip"]').tooltip('dispose');
            root.find("input").each(function(){
                const $el = $(this);
                if ($el.data('inputmask-initialized')) {
                    try { ($el as any).inputmask('remove'); } catch {}
                    $el.removeData('inputmask-initialized');
                }
            });
            root.find('.multichosen').each(function(){
                try { ($(this) as any).chosen('destroy'); } catch {}
            });
        } catch {}
    }

}
